// import { EMPLOYEE_RESOURCE_LITERAL, INITIAL_SNACKBAR_DATA, refetchOnWindowFocus:false, VENDOR_RESOURCE_LITERAL } from "common/constants";
// import {
//   instanceOfIResource,
// } from "common/instance-method";
// import { IResponse, IServerError } from "models/common";
// import { IResource } from "models/resource";
// import React, { useEffect, useState } from "react";
// import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
// import { useSelector } from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";
// import { ResourceService } from "services/ResourceService";
// import { IAppState } from "store/reducers";
// import { format } from 'date-fns';

// import {
//   BackdropCircularProgress,
//   DeleteConfirmationDialog,
//   EnhancedDropDownRHFWithLabel,
//   EnhancedSnackbar,
//   FieldLayout,
//   IEnhancedDropDownItem,
//   LabelPosition,
//   StandardPanel,
//   TwoColumnLayout,
// } from "@websential/cosmic";
// import { Grid } from "@mui/material";
// import { FormProvider, useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { EmployeeSetupValidationSchema } from "./EmployeeValidator";
// import { ReourceSetupToolbar } from "./ResourceSetupToolbar";
// import { IDropDownListResponse } from "models";
// import { T4SlipService } from "services/T4SlipService";
// import { FieldWrapper } from "components/FieldWrapper/FieldWrapper";
// import { EmployeeInfoSetupFieldsPanel } from "./Panels/EmployeeInfoSetupFieldsPanel";
// import { Calendar } from "primereact/calendar";
// import { EmployeeAddressSetupFieldsPanel } from "./Panels/EmployeeAddressSetupFieldsPanel";
// import { FilingDataSetupFieldsPanel } from "./Panels/FilingDataSetupFieldsPanel";
// import { VendorInfoSetupFieldsPanel } from "./Panels/VendorInfoSetupFieldsPanel";
// import { VendorAddressSetupFieldsPanel } from "./Panels/VendorAddressSetupFieldsPanel";
// import { VendorSetupValidationSchema } from "./vendorValidator";
// import { T4ASlipService } from "services/T4ASlipService";
// import { PROVINCE_OF_EMPLOYMENT, getPROVINCE_OF_EMPLOYMENT } from "services/common/ProvinceService";
// export interface IResourceSetup {}
// const SINGLE_RECORD_DATA_QUERY_KEY = "resource-single-data-record";

// const useGetData = (
//   id: string | undefined,
//   dataRoleName: string,
//   clientId: string
// ) => {
//   return useQuery(
//     [SINGLE_RECORD_DATA_QUERY_KEY, id],
//     () => ResourceService.getById(id, dataRoleName, clientId),
//     refetchOnWindowFocus:false
//   );
// };

//   const convertObjToString = (str: string) => {
//     const jsonStringPoe = str as string;
//     const modifiedString = jsonStringPoe.replace(/(\w+):/g, '"$1":').replace(/'/g, '"');
//     return JSON.parse(modifiedString);
//   };
// export const ResourceSetup: React.FC<IResourceSetup> = () => {
//   const navigate = useNavigate();
//   const clientId = useSelector((state: IAppState) => state.client.id);
//   const [selectedResourceList, setSelectedResourceList] = useState<
//   IDropDownListResponse[]
//   >([{ label: "Create New", value: "create-new" }]);
//   const [selectedVendorList, setSelectedVendorList] = useState<
//   IDropDownListResponse[]
//   >([{ label: "Create New", value: "create-new" }]);
//   const [openDialog, setDialogOpen] = useState(false);
//   const [selectedResource, setSelectedResource] = useState("create-new");
//   const [selectedVendor, setSelectedVendor] = useState("create-new");
//   const [isLoadingData, setIsLoadingData] = useState(false);
//   const [dateOfBirthPlaceHolder, setDateOfBirthPlaceHolder] = useState('')
//   const [dateOfBirth, setDateOfBirth] = useState<any>('')
//   const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
//   const queryClient = useQueryClient();
//   const { id, resourceName } = useParams();


//   const employeeFormMethods = useForm<any>({
//     resolver: yupResolver(EmployeeSetupValidationSchema),
//     mode: "onBlur",
//     reValidateMode: "onChange",
//     // defaultValues: DEFAULT_VALUES,
//   });
//   const vendorFormMethods = useForm<any>({
//     resolver: yupResolver(VendorSetupValidationSchema),
//     mode: "onBlur",
//     reValidateMode: "onChange",
//     // defaultValues: DEFAULT_VALUES,
//   });

//   const { isPending: isSubmitting, mutate: submitFormFields } = useMutation(
//     ResourceService.create,
//     {
//       onSuccess: (res: IResource | IServerError | IResponse | any) => {
// 
//         if (instanceOfIResource(res)) {
//           queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
//           setSnackbarData({
//             open: true,
//             message: `${resourceName} has been added successfully!`,
//             severity: "success",
//           });
//         } else {
//           setSnackbarData({
//             open: true,
//             message: res.message,
//             severity: "error",
//           });
//         }
//          //Load EMployee DDL
//          const fetchEmployeeData = async () => {
//           try {
//             const response: any = await T4SlipService.getEmployeeDDL(clientId, EMPLOYEE_RESOURCE_LITERAL);
//            
//             if (response && Array.isArray(response)) {
//               let resources: IDropDownListResponse[] = response.map(
//                 (resourceItem: IDropDownListResponse) => ({
//                   // id: resourceItem.id,
//                   label: resourceItem.label,
//                   value: resourceItem.value,
//                 })
//               );
//               resources.unshift({
//                 label: "Create New",
//                 value: "create-new",
//               });
//               setSelectedResourceList(resources);
//             }
//           } catch (error) {
//             console.error("Error fetching data:", error);
//           }
//         };
//         fetchEmployeeData();

//         //Load Vendor DDL;
//         const fetchVendorData = async () => {
//           setIsLoadingData(true);
//           try {
//             if(resourceName){
//               const response: any = await T4ASlipService.getVendorDDL(clientId, VENDOR_RESOURCE_LITERAL);
//        
//             if (response && Array.isArray(response)) {
//               let vendors: IDropDownListResponse[] = response.map(
//                 (resourceItem: IDropDownListResponse) => ({
//                   // id: resourceItem.id,
//                   label: resourceItem.label,
//                   value: resourceItem.value,
//                 })
//               );
//               vendors.unshift({
//                 label: "Create New",
//                 value: "create-new",
//               });
//               setSelectedVendorList(vendors);
//             }
//           }
//           setIsLoadingData(false);
//           } catch (error) {
//             console.error("Error fetching data:", error);
//             setIsLoadingData(false);
//           }
//         };
//         fetchVendorData();
//         //load resource Data
//         if (res) {
//           // setResourceRecord(res)
//           // const AccosiationIdGet = async () => {
//           //   try {
//           //     const response: any = await T4SlipService.getRoleAssociationId(res.id);
//          
//           //     setSelectedResource(response.associationId)
//           //     setSelectedVendor(response.associationId)
//           //   } catch (error) {
//           //     console.error("Error fetching data:", error);
//           //   }
//           // };
//           // AccosiationIdGet();
//           let path = `/resources/${resourceName}/setup/${res.id}`;
//           navigate(path)
//         }
//       },
//       onError: (err) => {
//         // TODO: customize the toast message based on the response
//         setSnackbarData({
//           open: true,
//           message: "Something went wrong, try again later!",
//           severity: "error",
//         });
//       },
//     }
//   );

//   const { isPending: isLoadingById, data: selectedDataRecord } = useGetData(
//     id,
//     String(resourceName),
//     clientId
//   );


//   useEffect(() => {
//     // if the selected Employee data has loaded.
//     if(resourceName === "Employee"){
//     if (selectedDataRecord) {
//       Object.keys(selectedDataRecord).forEach((fieldName) => {
//         // @ts-ignore
//         const fieldValue = selectedDataRecord[fieldName];
//    
//         employeeFormMethods.setValue(fieldName, fieldValue);

//         if (fieldName === "address") {
//           Object.keys(fieldValue).forEach((resourceFieldName) => {
//             const resourceFieldValue = fieldValue[resourceFieldName];
//             Object.keys(resourceFieldValue).forEach((resourceFieldNameNew) => {
//               const resourceFieldValueNew =
//                 resourceFieldValue[resourceFieldNameNew];
//               employeeFormMethods.setValue(resourceFieldNameNew, resourceFieldValueNew);

//               if (resourceFieldNameNew === "country") {
//                 employeeFormMethods.setValue(
//                   resourceFieldNameNew,
//                   resourceFieldValueNew.name ?? undefined
//                 );
//               }
//               if (resourceFieldNameNew === "province") {
//                 let id = resourceFieldValueNew.id;
//                 let name = resourceFieldValueNew.name;
//                 let shortCode = resourceFieldValueNew.shortCode;


//                 employeeFormMethods.setValue(
//                   resourceFieldNameNew,
//                   `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
//                   // '{id:1, name: "Alberta",shortCode:"AB"}'
//                 );
//               }
//             });
//           });
//         }
//         if (fieldName === "id") {
//           (async () => {
//             setIsLoadingData(true);
//             try {
//               const responseAssociationId = await T4SlipService.getRoleAssociationId(
//                 fieldValue
//               );
//               employeeFormMethods.setValue("selectedEmployee", responseAssociationId.associationId);
//               setSelectedResource(responseAssociationId.associationId)
//               setSelectedVendor("create-new")
//             } catch (error) {
//               console.error("Error fetching data:", error);
//             }
//             setIsLoadingData(false);
//           })();
//         }
//         if(fieldName === 'uniqueIdentifier'){
//           const formattedNumber = fieldValue.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3");
//           employeeFormMethods.setValue("uniqueIdentifier",formattedNumber);
//         }
//       if(fieldName === 'metaFields'){
//         fieldValue.forEach((obj:any) => {
//           employeeFormMethods.setValue(obj.name,obj.value)
//             if(obj.name === 'initials'){
//               employeeFormMethods.setValue('initials',obj.value)
//             }
//             if(obj.name === 'employee_code'){
//               employeeFormMethods.setValue('employeeCode',obj.value)
//             }
//             if(obj.name === 'pay_period'){
//               employeeFormMethods.setValue('payPeriod',obj.value)
//             }
//             if(obj.name === 'province_of_employment'){
//               getPROVINCE_OF_EMPLOYMENT(obj.value)
//          
//               if(PROVINCE_OF_EMPLOYMENT !== ''){
//                 employeeFormMethods.setValue("provinceOfEmployment",PROVINCE_OF_EMPLOYMENT);
//               }
//               // setShowbox17IfQC(true)
//             }
//             if(obj.name === 'reduced_ei'){
//                 employeeFormMethods.setValue('reducedEi',obj.value)
//             }
//             if(obj.name === 'date_of_birth'){
//               if(obj.value !== ""){
//               employeeFormMethods.setValue('dateOfBirth',obj.value)
//               if(obj.value.charAt(2) === "*"){
//                 employeeFormMethods.setValue('dateOfBirth', obj.value);
//               setDateOfBirth(obj.value)
//               }else{
//                 const defaultDate = new Date(obj.value);
//                 employeeFormMethods.setValue('dateOfBirth', defaultDate);
//                 setDateOfBirth(formatDate(defaultDate as Date))
//               }
//               setDateOfBirthPlaceHolder(obj.value)
//             }
//             }
//             if(obj.name === 'cpp_qpp_exempt'){
//                 employeeFormMethods.setValue('cppQppExempt',obj.value)
//             }
//             if(obj.name === 'ppip_exempt'){
//                 employeeFormMethods.setValue('ppipExempt',obj.value)
//             }
//             if(obj.name === 'ei_exempt'){
//                 employeeFormMethods.setValue('eiExempt',obj.value)
//             }
//             if(obj.name === 'employment_code'){
//               employeeFormMethods.setValue('employmentCode',obj.value)
//             }
//          
//         })
//       }
//       });
//       }
//     } else {
//       // if the selected Vendor data has loaded.
//       if (selectedDataRecord) {
//         Object.keys(selectedDataRecord).forEach((fieldName) => {
//           // @ts-ignore
//           const fieldValue = selectedDataRecord[fieldName];
//          
//           vendorFormMethods.setValue(fieldName, fieldValue);

//           if (fieldName === "address") {
//             Object.keys(fieldValue).forEach((resourceFieldName) => {
//               const resourceFieldValue = fieldValue[resourceFieldName];
//               Object.keys(resourceFieldValue).forEach((resourceFieldNameNew) => {
//                 const resourceFieldValueNew =
//                   resourceFieldValue[resourceFieldNameNew];
//                 vendorFormMethods.setValue(resourceFieldNameNew, resourceFieldValueNew);
//                 if (resourceFieldNameNew === "country") {
//                   vendorFormMethods.setValue(
//                     resourceFieldNameNew,
//                     resourceFieldValueNew.name ?? undefined
//                   );
//                 }
//                 if (resourceFieldNameNew === "province") {
//                   let id = resourceFieldValueNew.id;
//                   let name = resourceFieldValueNew.name;
//                   let shortCode = resourceFieldValueNew.shortCode;

//                  
//                   vendorFormMethods.setValue(
//                     resourceFieldNameNew,
//                     `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
//                     // '{id:1, name: "Alberta",shortCode:"AB"}'
//                   );
//                 }
//               });
//             });
//           }
//           if (fieldName === "id") {
//             (async () => {
//               setIsLoadingData(true);
//               try {
//                 const responseAssociationId = await T4SlipService.getRoleAssociationId(
//                   fieldValue
//                   );
//       
//                   vendorFormMethods.setValue("selectedVendor", responseAssociationId.associationId);
//                   setSelectedVendor(responseAssociationId.associationId)
//                   setSelectedResource("create-new")

//                 } catch (error) {
//                   console.error("Error fetching data:", error);
//                 }
//               setIsLoadingData(false);
//           })();
//         }
//         if(fieldName === 'uniqueIdentifier'){
//           const formattedNumber = fieldValue.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3");
//           vendorFormMethods.setValue("uniqueIdentifier",formattedNumber);
//         }
//           if(fieldName === 'metaFields'){
//             fieldValue.forEach((obj:any) => {
//               if(obj.name === 'payee_type'){
//                 vendorFormMethods.setValue('payeeType',obj.value)
//               } else if(obj.name === 'initial'){
//                 vendorFormMethods.setValue('initials',obj.value)
//               }
//               vendorFormMethods.setValue(obj.name,obj.value)
//             })
//           }
//         });
//         }
//     }
//   }, [selectedDataRecord, employeeFormMethods.setValue, employeeFormMethods, vendorFormMethods.setValue, vendorFormMethods]);

//   const onSubmit = (formData: any) => {
//     
//     if(resourceName === 'Employee'){
//       let employeeRequestPayload = {
//         clientId: clientId,
//         id:selectedDataRecord  ? selectedDataRecord.id : undefined,
//         dataRoleName: resourceName,
//         fixedFields:{
//           name1: formData.name1,
//           name2: formData.name2,
//           uniqueIdentifier: formData.uniqueIdentifier.replace(/-/g, ''),
//           businessName: formData.businessName,
//           businessNumber: formData.businessNumber && formData.businessNumber.replace(/(\d{9})(\d{4})/, '$1RP$2'),
//           statusId:formData.statusId,
//           address:[{
//             addressLine1:formData.addressLine1,
//             city: formData.city,
//             countryId:"1",
//             provinceId:convertObjToString(formData.province).id.toString(),
//             postalCode: formData.postalCode,
//           }]
//         },
//         metaFields: [
//           {fieldId:"26",name:"reduced_ei",value:formData.reducedEi},
//           {fieldId:"25",name:"pay_period",value:formData.payPeriod},
//           {fieldId:"24",name:"employment_code",value:formData.employmentCode},
//           {fieldId:"20",name:"province_of_employment",value:convertObjToString(formData.provinceOfEmployment).id.toString()},
//           {fieldId:"19",name:"ext2",value:formData.ext2},
//           {fieldId:"18",name:"phone2",value:formData.phone2 && formData.phone2.replace(/\D/g, '')},
//           {fieldId:"17",name:"ext1",value:formData.ext1},
//           {fieldId:"16",name:"phone1",value:formData.phone1 && formData.phone1.replace(/\D/g, '')},
//           {fieldId:"15",name:"email",value:formData.email},
//           {fieldId:"7",name:"employee_type",value:formData.employee_type},
//           {fieldId:"5",name:"employee_code",value:formData.employeeCode},
//           {fieldId:"4",name:"date_of_birth",value:formData.dateOfBirth && formData.dateOfBirth.charAt(2) === "*" ? "" : dateOfBirth !== "" || null ? dateOfBirth : ""},
//           {fieldId:"3",name:"initials",value:formData.initials},
//           {fieldId:"21",name:"cpp_qpp_exempt",value:formData.cppQppExempt},
//           {fieldId:"22",name:"ei_exempt",value:formData.eiExempt},
//           {fieldId:"23",name:"ppip_exempt",value:formData.ppipExempt},
//         ]
//       }
//
//       submitFormFields(employeeRequestPayload);
//     } else {
//       let vendorRequestPayload = {
//         clientId: clientId,
//         id:selectedDataRecord  ? selectedDataRecord.id : undefined,
//         dataRoleName: resourceName,
//         fixedFields:{
//           name1: formData.name1,
//           name2: formData.name2,
//           uniqueIdentifier: formData.uniqueIdentifier.replace(/-/g, ''),
//           businessName: formData.businessName,
//           businessNumber: formData.businessNumber && formData.businessNumber.replace(/(\d{9})(\d{4})/, '$1RP$2'),
//           statusId:formData.statusId,
//           address:[{
//             addressLine1:formData.addressLine1,
//             city: formData.city,
//             countryId:"1",
//             provinceId:convertObjToString(formData.province).id.toString(),
//             postalCode: formData.postalCode,
//           }]
//         },
//         metaFields: [
//           {fieldId:"4",name:"initial",value:formData.initials},
//           {fieldId:"15",name:"email",value:formData.email},
//           {fieldId:"16",name:"phone1",value:formData.phone1 && formData.phone1.replace(/\D/g, '')},
//           {fieldId:"17",name:"ext1",value:formData.ext1},
//           {fieldId:"18",name:"phone2",value:formData.phone2 && formData.phone2.replace(/\D/g, '')},
//           {fieldId:"19",name:"ext2",value:formData.ext2},
//           ]
//       }
//     
//       submitFormFields(vendorRequestPayload);
//     }
//   };

//   const onSnackbarClosed = (
//     _event: React.SyntheticEvent | Event,
//     reason?: string
//   ) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setSnackbarData(INITIAL_SNACKBAR_DATA);
//   };

// const onResetClicked = () => {
//   setSnackbarData({
//     open: true,
//     message: "Form was reset successfully",
//     severity: "success",
//   });
//   employeeFormMethods.reset();
//   vendorFormMethods.reset();
//   let path = `/resources/${resourceName}/setup`;
//   navigate(path);
// };

// const onResourceSelectionChangeHandler = async (
//   selectedItem: IEnhancedDropDownItem
// ): Promise<void> => {
//

//   if(selectedItem.value === "create-new"){
//     setIsLoadingData(true);
//     setSnackbarData({
//       open: true,
//       message: "Please load an Employee",
//       severity: "error",
//     });
//     employeeFormMethods.reset()
//     setDateOfBirth('')
//     setDateOfBirthPlaceHolder('')
//     let path = `/resources/${resourceName}/setup`;
//     navigate(path);
//     setSelectedResource("create-new");
//     setIsLoadingData(false);
//   } else {
//   try {
//     const response = await T4SlipService.getResourceActualId(
//       selectedItem.value
//     );

//  
//     setSelectedResource(String(response.resourceId));
//     let path = `/resources/${resourceName}/setup/${response.resourceId}`;
//     navigate(path);
//   } catch (err) {
//   
//   }
// }
// };
// const onVendorSelectionChangeHandler = async (
//   selectedItem: IEnhancedDropDownItem
// ): Promise<void> => {


//   if(selectedItem.value === "create-new"){
//     setIsLoadingData(true);
//     setSnackbarData({
//       open: true,
//       message: "Please load an Vendor",
//       severity: "error",
//     });
//     vendorFormMethods.reset()
//     let path = `/resources/${resourceName}/setup`;
//     navigate(path);
//     setSelectedResource("create-new");
//     setIsLoadingData(false);
//   } else {
//   try {
//     const response = await T4SlipService.getResourceActualId(
//       selectedItem.value
//     );
// 
//     setSelectedVendor(String(response.resourceId));
//     let path = `/resources/${resourceName}/setup/${response.resourceId}`;
//     navigate(path);
//   } catch (err) {

//   }
// }
// };

// const formatDate = (date: Date): string => {
//   return format(date, 'yyyy-MM-dd'); // Format the date as "yyyy-MM-dd"
// };

// const onDateOfBirthChangeHandler = (selectedDate: any) => {

//   // alert(formatDate(selectedDate.value as Date));
//   setDateOfBirth(formatDate(selectedDate.value as Date))
// };

// useEffect(() => {
//   //Load Resource DDL;
//   const fetchData = async () => {
//     setIsLoadingData(true);
//     try {
//       if(resourceName){
//         const response: any = await T4SlipService.getEmployeeDDL(clientId, EMPLOYEE_RESOURCE_LITERAL);
//      

//       if (response && Array.isArray(response)) {
//         let resources: IDropDownListResponse[] = response.map(
//           (resourceItem: IDropDownListResponse) => ({
//             // id: resourceItem.id,
//             label: resourceItem.label,
//             value: resourceItem.value,
//           })
//         );

//         resources.unshift({
//           label: "Create New",
//           value: "create-new",
//         });

//         setSelectedResourceList(resources);
//       }
//     }
//     setIsLoadingData(false);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setIsLoadingData(false);
//     }
//   };

//   fetchData();

// }, []);

// useEffect(() => {
//   //Load Vendor DDL;
//   const fetchData = async () => {
//     setIsLoadingData(true);
//     try {
//       if(resourceName){
//         const response: any = await T4ASlipService.getVendorDDL(clientId, VENDOR_RESOURCE_LITERAL);
//       

//       if (response && Array.isArray(response)) {
//         let vendors: IDropDownListResponse[] = response.map(
//           (resourceItem: IDropDownListResponse) => ({
//             // id: resourceItem.id,
//             label: resourceItem.label,
//             value: resourceItem.value,
//           })
//         );

//         vendors.unshift({
//           label: "Create New",
//           value: "create-new",
//         });

//         setSelectedVendorList(vendors);
//       }
//     }
//     setIsLoadingData(false);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setIsLoadingData(false);
//     }
//   };
//   fetchData();
// }, []);

// const onCloseHandler = () => {
//   setDialogOpen(false);
// };

// // for delete row
// const [singleDelete, setSingleDelete] = useState<boolean>(false);
// const [resourceId, setResourceId] = useState<number>(0);

// const { isPending: isDeleting, mutate: deleteResourceById } = useMutation(
//     ResourceService.delResource,
//     {
//       onSuccess: (res: string | IServerError | IResponse | any) => {
//         if (typeof res === "string") {
//           // remove the cache of the Year fields since we just added a new field.
//           setSnackbarData({
//             open: true,
//             message: "Record has been deleted successfully.",
//             severity: "success",
//           });

//           // return queryClient.invalidateQueries(apiKey);
//         } else {
//           setSnackbarData({
//             open: true,
//             message: res.message,
//             severity: "error",
//           });
//         }
//         employeeFormMethods.reset()
//         vendorFormMethods.reset()
//         let path = `/resources/${resourceName}/setup`;
//         navigate(path);
//       },
//       onError: (err:any) => {
//         // TODO: customize the toast message based on the response
//         setSnackbarData({
//           open: true,
//           message: err.message,
//           severity: "error",
//         });
//       },
//     }
//   );

// // For Delete Row
// const deleteResourceField = () => {
//   if (singleDelete) {
//     setSingleDelete(false);
//     let payload = {
//       resourceId:resourceId,
//       clientId:clientId
//     }
//     deleteResourceById(payload);
//     setDialogOpen(false);
//   }
// };

// const onDeleteClicked = () => {
//   setDialogOpen(true);
//   setSingleDelete(true);
//   // setApiAction("delete");
//   // setResourceId(params.row.id);
//   if(selectedDataRecord){
//     setResourceId(selectedDataRecord.id)
//   }
//   vendorFormMethods.setValue("selectedVendor", "0731f171-da8f-446d-8041-5e7978adc3bb");
// };



//   return (
//     <>
//     {resourceName !== "Vendor" ? (
//       <>
//        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12}} sx={{ pb: "5rem", "& .MuiAppBar-root":{zIndex:2}, "& .p-datepicker":{zIndex:2}}}>
//         <BackdropCircularProgress
//           open={
//             isSubmitting ||
//             isLoadingById ||
//             isLoadingData
//             || isDeleting
//           }
//           testId=""
//         />
//         <DeleteConfirmationDialog
//           open={openDialog}
//           deleteActionHandler={deleteResourceField}
//           cancelActionHandler={onCloseHandler}
//           testId="resource-confirmation-dialog"
//         />
//         <FormProvider {...employeeFormMethods}>
//           <form onSubmit={employeeFormMethods.handleSubmit(onSubmit)}>
//             <TwoColumnLayout
//               toolbar={
//                 <ReourceSetupToolbar
//                   onResetClicked={onResetClicked}
//                   onDeleteClicked={onDeleteClicked}
//                   isSubmitting={isSubmitting}
//                   formMethods={employeeFormMethods}
//                 />
//               }
//               leftColumnContent={
//                 <>
//                   <StandardPanel
//                     title="Load Employee"
//                     testId={`load-Employee-panel`}
//                   >
//                     <Grid
//                       container
//                       // columnSpacing={2}
//                       xs={12}
//                       sm={12}
//                       md={12}
//                       lg={12}
//                       xl={12}
//                     >
//                         <EnhancedDropDownRHFWithLabel
//                           label="Load Employee"
//                           selectName="selectedEmployee"
//                           items={selectedResourceList}
//                           selectedItem={selectedResource}
//                           testId="selected-employee"
//                           onSelectionChangeHandler={
//                             onResourceSelectionChangeHandler
//                           }
//                           // isLoading={isLoadingFlexFieldsList}
//                         />
//                     </Grid>
//                   </StandardPanel>
//                   <StandardPanel
//                     title="Employee Info"
//                     testId={`-employee-info`}
//                     topPadding={2}
//                   >
//                     <EmployeeInfoSetupFieldsPanel/>
//                      <FieldWrapper>
//                       <FieldLayout
//                           label="Date of Birth"
//                           // isRequired={isRequired}
//                           testId=""
//                           labelPosition={LabelPosition.Left}
//                           labelColumns={4}
//                           fieldColumns={8}
//                           >
//                           <Calendar
//                             id="dateOfBirth"
//                             {...employeeFormMethods.register('dateOfBirth')} // Register the input with react-hook-form using methods.register
//                             value={employeeFormMethods.watch('dateOfBirth') || null} // Set the value using watch to reflect changes
//                             showIcon
//                             placeholder={dateOfBirthPlaceHolder !== "" && dateOfBirthPlaceHolder.charAt(2) === '*' ? 'Unmask to view / edit' : 'dd/mm/yyyy'}
//                             disabled={dateOfBirthPlaceHolder !== "" && dateOfBirthPlaceHolder.charAt(2) === '*'}  //if unmask then it is enabled
//                             className="w-full"
//                             style={{ height: '2.6rem',marginTop:"4px",marginBottom:"4.3rem" }}
//                             onChange={onDateOfBirthChangeHandler}
//                           />
//                         </FieldLayout>
//                     </FieldWrapper>
//                   </StandardPanel>
//                 </>
//               }
//               rightColumnContent={
//                 <>
//                   <StandardPanel
//                     title="Address"
//                     testId={`-employee-address-panel`}
//                   >
//                     <EmployeeAddressSetupFieldsPanel testId={""} />
//                   </StandardPanel>

//             <StandardPanel
//                     title="Filing Data Attributes"
//                     testId={`-filing-data-panel`}
//                     topPadding={2}
//                   >
//                     <FilingDataSetupFieldsPanel />
//             </StandardPanel>
//                 </>
//               }
//               testId="resource-setup-form"
//             />
//           </form>
//         </FormProvider>
//         </Grid>
//         <EnhancedSnackbar
//         message={snackbarData.message}
//         onCloseHandler={onSnackbarClosed}
//         severity={snackbarData.severity}
//         testId={`snackbar`}
//         open={snackbarData.open}
//       />
//       </>
//     ):(
//       <>
//       <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12}} sx={{ pb: "5rem", "& .MuiAppBar-root":{zIndex:2}, "& .p-datepicker":{zIndex:2}}}>
//         <BackdropCircularProgress
//           open={
//             isSubmitting ||
//             isLoadingById ||
//             isLoadingData
//             || isDeleting
//           }
//           testId=""
//         />
//         <DeleteConfirmationDialog
//           open={openDialog}
//           deleteActionHandler={deleteResourceField}
//           cancelActionHandler={onCloseHandler}
//           testId="resource-confirmation-dialog"
//         />
//         <FormProvider {...vendorFormMethods}>
//           <form onSubmit={vendorFormMethods.handleSubmit(onSubmit)}>
//             <TwoColumnLayout
//               toolbar={
//                 <ReourceSetupToolbar
//                   onResetClicked={onResetClicked}
//                   onDeleteClicked={onDeleteClicked}
//                   isSubmitting={isSubmitting}
//                   formMethods={vendorFormMethods}
//                 />
//               }
//               leftColumnContent={
//                 <>
//                   <StandardPanel
//                     title="Load Vendor"
//                     testId={`load-Vendor-panel`}
//                   >
//                     <Grid
//                       container
//                       // columnSpacing={2}
//                       xs={12}
//                       sm={12}
//                       md={12}
//                       lg={12}
//                       xl={12}
//                     >
//                         <EnhancedDropDownRHFWithLabel
//                           label="Load Vendor"
//                           selectName="selectedVendor"
//                           items={selectedVendorList}
//                           selectedItem={selectedVendor}
//                           testId="selected-Vendor"
//                           onSelectionChangeHandler={
//                             onVendorSelectionChangeHandler
//                           }
//                           // isLoading={isLoadingFlexFieldsList}
//                         />
//                     </Grid>
//                   </StandardPanel>
//                   <StandardPanel
//                     title="Vendor Info"
//                     testId={`-Vendor-info`}
//                     topPadding={2}
//                   >
//                     <VendorInfoSetupFieldsPanel testId={""}/>
//                   </StandardPanel>
//                 </>
//               }
//               rightColumnContent={
//                 <>
//                   <StandardPanel
//                     title="Address"
//                     testId={`vendor-address-panel`}
//                   >
//                     <VendorAddressSetupFieldsPanel testId={""} />
//                   </StandardPanel>
//                 </>
//               }
//               testId="resource-setup-form"
//             />
//           </form>
//         </FormProvider>
//         </Grid>
//         <EnhancedSnackbar
//           message={snackbarData.message}
//           onCloseHandler={onSnackbarClosed}
//           severity={snackbarData.severity}
//           testId={`snackbar`}
//           open={snackbarData.open}
//         />
//         </>
//     )}
//     </>
//   );
// };

// old Code with tab/stepper form

import { AddressFields, FlexFieldsUtils } from "../../../common/FlexFieldsUtils";
import {
  BackdropCircularProgress,
  DataType,
  DeleteConfirmationDialog,
  EnhancedDialog,
  EnhancedDropDownRHFWithLabel,
  EnhancedSnackbar,
  FieldType,
  IPanel,
  ITabLayout,
  StandardPanel,
} from "@websential/cosmic";
import { Box, Button, Card, Grid, GridSize, Typography } from "@mui/material";
import {
  EMPLOYEE_RESOURCE_LITERAL,
  EMPLOYEE_SETUP_SCREEN_ID,
  EMPLOYEE_SETUP_SCREEN_SLUG,
  INITIAL_SNACKBAR_DATA,
  T3_BENEFICIARY_SETUP_SCREEN_SLUG,
  T5_RECIPIENT_RESOURCE_LITERAL,
  T5_RECIPIENT_SETUP_SCREEN_ID,
  T5_RECIPIENT_SETUP_SCREEN_SLUG,
  VENDOR_RESOURCE_LITERAL,
  VENDOR_SETUP_SCREEN_ID,
  VENDOR_SETUP_SCREEN_SLUG,
} from "../../../common/constants";
import {
  FIELD_TYPE_COMPONENT,
  FlexFieldsFormPanelLayout,
  getFieldName,
  getMultiSelectionDDLDefaultValue,
} from "../../../components/Accountant/AccountantSetup/FlexFieldsFormPanelLayout";
import { IResponse, IServerError } from "../../../models/common";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  clearSelectedResourceApiMessageActions,
  setSelectedResourceApiMessageActions,
} from "../../../store/actions/resourceApiMessageActions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";

import { AccountantSetupToolbar } from "../../../components/Accountant/AccountantSetup/AccountantSetupToolbar";
import { Avatar } from "primereact/avatar";
import { CategoryFieldsPanelLayout } from "../../../components/Accountant/AccountantSetup/CategoryFieldsPanelLayout";
import { ClientService } from "../../../services";
import { DefaultSettingsService } from "../../../services/DefaultSettingsService";
import DeleteIcon from "@mui/icons-material/Delete";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { EnhancedTextField } from "@websential/cosmic/build/components/EnhancedTextField";
import { IAppState } from "../../../store/reducers";
import IField from "@websential/cosmic/build/components/RHookFormGenerator/types/IField";
import { IResource } from "../../../models/resource";
import { InputText } from "primereact/inputtext";
import { ReourceSetupToolbar } from "./ResourceSetupToolbar";
import { ResourceService } from "../../../services/ResourceService";
import { SetupFormLayout } from "../../../layouts/SetupFormLayout";
import { T4SlipService } from "../../../services/T4SlipService";
import dayjs from "dayjs";
import { format } from "date-fns";
import { instanceOfIResource } from "../../../common/instance-method";
import { resourceJSONdataValidation } from "./resourceJSONdataValidation";
import { setSelectedActivityLogActions } from "../../../store/actions/activityLogActions";
import { setSelectedStickyNavBar } from "../../../store/actions/stickyNavBarActions";
import { sortDDLByLabel } from "../../../common/Common";

export interface IResourceSetup { }
const DEFAULT_SETTINGS_DATA_QUERY_KEY = "default-settings-data-record";
const SINGLE_RECORD_DATA_QUERY_KEY = "resource-single-data-record";

const formatDate = (date: Date): string => {

  return format(date, "yyyy-MM-dd"); // Format the date as "yyyy-MM-dd"
};

const useGetData = (
  id: string | undefined,
  dataRoleName: string,
  clientId: string
) =>
  useQuery({
    queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id],
    queryFn: () => { return ResourceService.getById(id, dataRoleName, clientId) },
    refetchOnWindowFocus: false

  });

// const useScreenLayout: any = (resourceName: string) =>
//   useQuery({
//     queryKey: [`${resourceName.toLowerCase()}-resource-setup-layout`],
//     queryFn: (data) => {
//       return ResourceService.getSetupLayout(resourceName);
//     },
//     refetchOnWindowFocus: false
//   });

const useEmployeeScreenLayout: any = () =>
  useQuery({
    queryKey: [`employee-resource-setup-layout`],
    queryFn: (data) => {
      return ResourceService.getEmployeeSetupLayout();
    },
    refetchOnWindowFocus: false
  });

// const useVendorScreenLayout: any = (payeeType:boolean) =>
//   useQuery(
//     [`vendor-resource-setup-layout`,payeeType],
//     (data) => {
//       return ResourceService.getVendorSetupLayout(payeeType);
//     },
//     refetchOnWindowFocus: false
//   );
const VENDOR_FIELDS_DATA_QUERY_KEY = `vendor-resource-setup-layout`;
const useVendorScreenLayout = (payeeType: string) =>
  useQuery({
    queryKey: [VENDOR_FIELDS_DATA_QUERY_KEY, payeeType],
    queryFn: () => { return ResourceService.getVendorSetupLayout(payeeType) },
    refetchOnWindowFocus: false
  });


const T5_RECIPIENT_FIELDS_DATA_QUERY_KEY = `t5-recipient-resource-setup-layout`;
const useT5RecipientScreenLayout = (recipientType: number) =>
  useQuery({
    queryKey: [T5_RECIPIENT_FIELDS_DATA_QUERY_KEY, recipientType],
    queryFn: () => { return ResourceService.getT5RecipientSetupLayout(recipientType) },
    refetchOnWindowFocus: false
  });


const T3_Beneficiary_FIELDS_DATA_QUERY_KEY = `t3-beneficiary-resource-setup-layout`;
const useT3BeneficiaryScreenLayout = (recipientType: number) =>
  useQuery({
    queryKey: [T3_Beneficiary_FIELDS_DATA_QUERY_KEY, recipientType],
    queryFn: () => { return ResourceService.getT3BeneficiarySetupLayout(recipientType) },
    refetchOnWindowFocus: false
  });


const ASSINGED_CATEGORY_DATA_QUERY_KEY = `resource-category-data-record`;
const ASSINGED_CATEGORY_PANEL_QUERY_KEY = `resource-category-panel-record`;

// const useGetAssignedCategoryPanel = (selectedCategoriesData: any) =>
//   useQuery({
//     queryKey: [ASSINGED_CATEGORY_PANEL_QUERY_KEY, selectedCategoriesData],
//     queryFn: () => {
//       return ResourceService.getResourceCategoriesAssingedPanels(
//         selectedCategoriesData
//       )
//     },
//     refetchOnWindowFocus: false
//   });

// const useGetResourceCategories = (
//   screenId: string | number,
//   resourceName: string | undefined
// ) => useQuery({
//   queryKey: [ASSINGED_CATEGORY_DATA_QUERY_KEY, screenId, resourceName],
//   queryFn: () => { return ResourceService.getResourceCategories(screenId, resourceName) },
//   refetchOnWindowFocus: false
// });

// const useGetDefaultSettingsData = (
//   clientId: string,
// ) =>
//   useQuery({
//     queryKey: [DEFAULT_SETTINGS_DATA_QUERY_KEY, clientId],
//     queryFn: (data) => {
//       return DefaultSettingsService.getDefaultSettings(clientId);
//     },
//     refetchOnWindowFocus: false
//   });

// const useGetClientProfileData = (id: string | undefined) =>
//   useQuery({
//     queryKey: ['client-single-data-record', id],
//     queryFn: (data) => {
//       return ClientService.getById(id);
//     },
//     refetchOnWindowFocus: false
//   });


const EMPLOYEE_DDL_DATA_QUERY_KEY = "employee-ddl-data-record";
const useGetEmployeeDDLItems = (clientId: string, dataRole: string, taxYear: number) =>
  useQuery({
    queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, dataRole, taxYear],
    queryFn: (data) => {
      return T4SlipService.getEmployeeDDL(clientId, dataRole, taxYear);
    },
    refetchOnWindowFocus: false,
  });
export const ResourceSetup: React.FC<IResourceSetup> = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const flexFieldPanelHeightRef = useRef<any>(null);
  const clientName = useSelector((state: IAppState) => state.client.clientName);
  const isLoadingActivityLogData = useSelector(
    (state: IAppState) => state.isLoadAxiosCall.isLoading
  );
  const homePathRoute = useSelector(
    (state: IAppState) => state.HomePagePath.path
  );
  const clientId = useSelector((state: IAppState) => state.client.id);
  const taxYear = useSelector((state: IAppState) => state.taxYear.year);
  const resourceApiMessage = useSelector(
    (state: IAppState) => state.resourceApiMessage
  );
  const dashboardApiData = useSelector((state: IAppState) => state.dashboardApisData)
  const [metaFieldIds, setMetaFieldIds] = useState({});
  const [renderForm, setRenderForm] = useState(false);
  const [screenFields, setScreenFields] = useState<any>(undefined);
  const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
  const [openDialog, setDialogOpen] = useState(false);
  const [singleDelete, setSingleDelete] = useState<boolean>(false);
  const [resourceId, setResourceId] = useState<number>(0);
  const [payeeType, setPayeeType] = useState("true");
  const [recipientType, setRecipientType] = useState(10);
  const [selectedResourceList, setSelectedResourceList] =
    useState<any>(undefined);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [showCreatedResourceMessage, setshowCreatedResourceMessage] =
    useState(true);
  const [recipientTypeChangeOnEditMode, setRecipientTypeChangeOnEditMode] =
    useState(true);
  const [
    categoryFieldsWithOnChangeMethod,
    setCategoryFieldsWithOnChangeMethod,
  ] = useState<any>(undefined);
  const [resourceTotalPanels, setResourceTotalPanels] =
    useState<any>(undefined);
  const [resourceTotalCategories, setResourceTotalCategories] =
    useState<any>(undefined);
  let screenId = 19;
  const queryClient = useQueryClient();
  const { id, resourceName } = useParams();

  const [editRecordId, setEditRecordId] = useState(id);
  // const [resourceListWithoutCreateNew, setResourceListWithoutCreateNew] =
  //   useState<any>(undefined);
  const [selectedCard, setSelectedCard] = useState<any>(null);
  const [itemSearch, setItemSearch] = useState("");
  const [sidePanelsVisibility, setSidePanelsVisibility] = useState(true);
  // const [flexFieldPanelHeight, setFlexFieldPanelHeight] = useState<any>(undefined);

  const { isPending: isSubmitting, mutate: submitFormFields } = useMutation({
    mutationFn: ResourceService.create,

    onSuccess: (res: IResource | IServerError | IResponse | any) => {
      if (res.status === 201) {
        if (res && res.data.id) {
          let path = `/resources/${resourceName}/setup/${res.data.id}`;
          navigate(path);
          setshowCreatedResourceMessage(false);
          dispatch(
            setSelectedResourceApiMessageActions({
              open: true,
              message: res.data.message
                ? res.data.message
                : `${resourceName === "T5_Recipient" ? "T5 Recipient" : resourceName === "T3_Beneficiary" ? "T3 Beneficiary" : resourceName} has been added successfully!`,
              severity: "success",
            })
          );
          window.location.reload();
        }
      } else if (res.status === 200) {
        if (res && res.data.id) {
          let path = `/resources/${resourceName}/setup/${res.data.id}`;
          navigate(path);
          setshowCreatedResourceMessage(false);
          dispatch(
            setSelectedResourceApiMessageActions({
              open: true,
              message: res.data.message
                ? res.data.message
                : `${resourceName === "T5_Recipient" ? "T5 Recipient" : resourceName === "T3_Beneficiary" ? "T3 Beneficiary" : resourceName} has been updated successfully!`,
              severity: "success",
            })
          );
          window.location.reload();
        }
      } else if (res.status === 400 && res && res.data.id) {
        let path = `/resources/${resourceName}/setup/${res.data.id}`;
        navigate(path);
        setshowCreatedResourceMessage(false);
        dispatch(
          setSelectedResourceApiMessageActions({
            open: true,
            message: `${resourceName} created successfully!`,
            severity: "success",
          })
        );
        window.location.reload();
      } else {
        setSnackbarData({
          open: true,
          message: res.data.message
            ? res.data.message
            : res.message
              ? res.message
              : "Something went wrong.",
          severity: "error",
        });
      }

      // let path = `/resources/${resourceName}/list`;
      // navigate(path);
    },
    onError: (err) => {
      // TODO: customize the toast message based on the response
      setSnackbarData({
        open: true,
        message: "Something went wrong, try again later!",
        severity: "error",
      });
    },
  }
  );

  // const { isLoading, data: screenFields } = useScreenLayout(resourceName);
  const { isPending: isPendingEmployeeDDLItems, data: employeeDDLItems } =
    useGetEmployeeDDLItems(clientId,
      resourceName === "Employee"
        ? EMPLOYEE_RESOURCE_LITERAL
        : resourceName === "Vendor"
          ? VENDOR_RESOURCE_LITERAL
          : resourceName === "T5_Recipient" ? T5_RECIPIENT_RESOURCE_LITERAL
            : 'T3_Beneficiary',
      taxYear);

  const { isLoadingEmployeeScreenLayout, data: employeeScreenFields } =
    useEmployeeScreenLayout();


  const { isPending: isLoadingVendorScreenLayout, data: vendorScreenFields } =
    useVendorScreenLayout(payeeType);


  const {
    isLoading: isLoadingT5RecipientScreenLayout,
    data: t5RecipientScreenFields,
  } = useT5RecipientScreenLayout(recipientType);


  const {
    isLoading: isLoadingT3BeneficiaryScreenLayout,
    data: t3BeneficiaryScreenFields,
  } = useT3BeneficiaryScreenLayout(recipientType);


  // const { isPending: isLoadingClientProfileDataById, data: clientProfileData } =
  //   useGetClientProfileData(clientId);

  const provincesDDL = [
    "Alberta",
    "British Columbia",
    "Manitoba",
    "New Brunswick",
    "NewfoundLand and Labrador",
    "Northwest Territories",
    "Nova Scotia",
    "Nunavut",
    "Ontario",
    "Prince Edward Island",
    "Quebec",
    "Saskatchewan",
    "Yukon"
  ];

  const getProvincesByIndices = (indices: any) => {
    return indices.map((index: any) => provincesDDL[index - 1]).join(",");
  };

  useEffect(() => {
    if (resourceName === "Employee" && employeeScreenFields && dashboardApiData && dashboardApiData.client_detail && dashboardApiData.client_detail.operatingProvinces) {
      const getPoeDdlAccourdingToClientOperatingProvinces = getProvincesByIndices(dashboardApiData.client_detail.operatingProvinces);
      const covertOperatingProvincesArraytoStr = dashboardApiData.client_detail.operatingProvinces.join(',');

      employeeScreenFields &&
        employeeScreenFields.forEach((item: any) => {
          item?.panels.forEach((screenPanel: IPanel) => {
            screenPanel?.fields?.forEach((field: IField) => {
              field.fieldValue =
                field.fieldId === "province_of_employment"
                  ? getPoeDdlAccourdingToClientOperatingProvinces
                  : field.fieldValue;
              field.fieldInternalValue =
                field.fieldId === "province_of_employment"
                  ? dashboardApiData.client_detail.operatingProvinces : field.fieldInternalValue;
            });
          });
        });
      setResourceTotalPanels(undefined);
      setScreenFields(employeeScreenFields);
    } else {
      setResourceTotalPanels(undefined);
      setScreenFields(employeeScreenFields);
    }
    if (resourceName === "Vendor" && vendorScreenFields) {
      setResourceTotalPanels(undefined);
      setScreenFields(vendorScreenFields);
    }
    if (resourceName === "T5_Recipient" && t5RecipientScreenFields) {
      setResourceTotalPanels(undefined);
      setScreenFields(t5RecipientScreenFields);
    }
  }, [
    resourceName,
    employeeScreenFields,
    vendorScreenFields,
    t5RecipientScreenFields,
  ]);
  useEffect(() => {
    if (resourceName === "T3_Beneficiary" && t3BeneficiaryScreenFields) {
      setResourceTotalPanels(undefined);
      setScreenFields(t3BeneficiaryScreenFields);
    }
  }, [
    t3BeneficiaryScreenFields
  ]);

  const {
    isLoading: isLoadingById,
    data: selectedDataRecord,
    refetch: refetchResourceDataById,
  } = useGetData(editRecordId, String(resourceName), clientId);

  // const { isPending: isLoadingDefaultSettingsData, data: defaultSettingsData } = useGetDefaultSettingsData(clientId);

  const [selectedCategoriesData, setSelectedCategoriesData] = useState<any>([]);

  // const {
  //   isLoading: isLoadingResourceCategoriesPanels,
  //   data: resourceCategoryAssingedPanels,
  // } = useGetAssignedCategoryPanel(selectedCategoriesData);

  // const { isPending: isLoadingResourceCategories, data: resourceCategoryList } =
  //   useGetResourceCategories(screenId, resourceName);


  // useEffect(() => {
  //   if (resourceCategoryList) {
  //     setResourceTotalCategories(resourceCategoryList);
  //   }
  // }, [resourceCategoryList]);

  const defaultSettingsCalls = () => {
    if (!id && !selectedDataRecord && dashboardApiData && dashboardApiData.default_setting && dashboardApiData.default_setting.fillingDataAttribute && resourceName === "Employee" && employeeScreenFields) {

      resourceTotalPanels &&
        resourceTotalPanels.forEach((item: any) => {
          item?.panels.forEach((screenPanel: IPanel) => {
            screenPanel?.fields?.forEach((field: IField) => {
              field.defaultValue =
                field.fieldId === "statusId"
                  ? field.defaultValue
                  : field.fieldId === "statusId"
                    ? field.defaultValue
                    : field.fieldId === "countryId"
                      ? field.defaultValue
                      : field.fieldId === "employee_type"
                        ? field.defaultValue
                        : field.fieldId === "province_of_employment" && dashboardApiData.default_setting.fillingDataAttribute.provinceOfEmployment && dashboardApiData.default_setting.fillingDataAttribute.provinceOfEmployment.id
                          ? dashboardApiData.default_setting.fillingDataAttribute.provinceOfEmployment.id
                          : field.fieldId === "city" && dashboardApiData.default_setting.fillingDataAttribute.city
                            ? dashboardApiData.default_setting.fillingDataAttribute.city
                            : field.fieldId === "provinceId" && dashboardApiData.default_setting.fillingDataAttribute.province && dashboardApiData.default_setting.fillingDataAttribute.province.id
                              ? String(dashboardApiData.default_setting.fillingDataAttribute.province.id)
                              : field.fieldId === "cpp_qpp_exempt" && dashboardApiData.default_setting.fillingDataAttribute.cppQppExempt
                                ? dashboardApiData.default_setting.fillingDataAttribute.cppQppExempt
                                : field.fieldId === "ei_exempt" && dashboardApiData.default_setting.fillingDataAttribute.eiExempt
                                  ? dashboardApiData.default_setting.fillingDataAttribute.eiExempt
                                  : field.fieldId === "ppip_exempt" && dashboardApiData.default_setting.fillingDataAttribute.ppipExempt
                                    ? dashboardApiData.default_setting.fillingDataAttribute.ppipExempt
                                    : field.fieldId === "employment_code" && dashboardApiData.default_setting.fillingDataAttribute.employmentCode
                                      ? dashboardApiData.default_setting.fillingDataAttribute.employmentCode
                                      : field.fieldId === "reduced_ei"
                                        ? dashboardApiData.default_setting.fillingDataAttribute.reducedEi === 0 ? "False" : "True"
                                        : field.fieldId === "pay_period"
                                          ? dashboardApiData.default_setting.fillingDataAttribute.payPeriod
                                          : null;
              field.isRequired =
                field.fieldId === "date_of_birth" && dashboardApiData.default_setting.fillingDataAttribute.employeeDobIsRequired
                  ? dashboardApiData.default_setting.fillingDataAttribute.employeeDobIsRequired : field.isRequired;
            });
          });
        });
    }
  }

  const onSubmit = (values: any) => {
    let employeeFlexFields: any = {
      ...values,
      ["postalCode-" + 12 + "-fixed"]:
        values["postalCode-" + 12 + "-fixed"] &&
        values["postalCode-" + 12 + "-fixed"].replace(
          /[a-z]/g,
          (match: string) => match.toUpperCase()
        ),
      ["name1-" + 3 + "-fixed"]:
        values["name1-" + 3 + "-fixed"] !== ""
          ? values["name1-" + 3 + "-fixed"]
          : undefined,
      ["email-" + 15 + "-fixed"]:
        values["email-" + 15 + "-fixed"] !== ""
          ? values["email-" + 15 + "-fixed"]
          : undefined,
      ["date_of_birth-" + 6]:
        values["date_of_birth-" + 6] && values["date_of_birth-" + 6] !== null
          ? formatDate(new Date(values["date_of_birth-" + 6]))
          : "",
      ["uniqueIdentifier-" + 2 + "-fixed"]:
        (values["uniqueIdentifier-" + 2 + "-fixed"] &&
          values["uniqueIdentifier-" + 2 + "-fixed"] !== "") ||
          null
          ? values["uniqueIdentifier-" + 2 + "-fixed"].replace(/-/g, "")
          : undefined,
      ["id-" + 27 + "-fixed"]:
        selectedDataRecord && selectedDataRecord.address[0].id
          ? selectedDataRecord.address[0].id
          : undefined,
      ["isPrimary-" + 28 + "-fixed"]: true,
      ["appAddressTypeId-" + 29 + "-fixed"]: 1,
    };
    let vendorFlexFields: any = {
      ...values,
      ["postalCode-" + 12 + "-fixed"]:
        values["postalCode-" + 12 + "-fixed"] &&
        values["postalCode-" + 12 + "-fixed"].replace(
          /[a-z]/g,
          (match: string) => match.toUpperCase()
        ),
      ["name1-" + 3 + "-fixed"]:
        values["name1-" + 3 + "-fixed"] !== ""
          ? values["name1-" + 3 + "-fixed"]
          : undefined,
      ["email-" + 15 + "-fixed"]:
        values["email-" + 15 + "-fixed"] !== ""
          ? values["email-" + 15 + "-fixed"]
          : undefined,
      ["uniqueIdentifier-" + 2 + "-fixed"]:
        (values["uniqueIdentifier-" + 2 + "-fixed"] &&
          values["uniqueIdentifier-" + 2 + "-fixed"] !== "") ||
          null
          ? values["uniqueIdentifier-" + 2 + "-fixed"].replace(/-/g, "")
          : undefined,
      // addressId:
      ["id-" + 27 + "-fixed"]:
        selectedDataRecord && selectedDataRecord.address[0].id
          ? selectedDataRecord.address[0].id
          : undefined,
      ["initials-" + 5]: values["initials-" + 5] ? values["initials-" + 5] : '',
      ["phone1-" + 16]: values["phone1-" + 16] ? values["phone1-" + 16] : '',
      ["isPrimary-" + 28 + "-fixed"]: true,
      ["appAddressTypeId-" + 29 + "-fixed"]: 1,
    };
    let t5RecipientFlexFields: any = {
      ...values,
      ["postalCode-" + 12 + "-fixed"]:
        values["postalCode-" + 12 + "-fixed"] &&
        values["postalCode-" + 12 + "-fixed"].replace(
          /[a-z]/g,
          (match: string) => match.toUpperCase()
        ),
      ["name1-" + 3 + "-fixed"]:
        values["name1-" + 3 + "-fixed"] !== ""
          ? values["name1-" + 3 + "-fixed"]
          : undefined,
      ["email-" + 15 + "-fixed"]:
        values["email-" + 15 + "-fixed"] !== ""
          ? values["email-" + 15 + "-fixed"]
          : undefined,
      ["uniqueIdentifier-" + 2 + "-fixed"]:
        (values["uniqueIdentifier-" + 2 + "-fixed"] &&
          values["uniqueIdentifier-" + 2 + "-fixed"] !== "") ||
          null
          ? values["uniqueIdentifier-" + 2 + "-fixed"].replace(/-/g, "")
          : undefined,
      // addressId:
      ["id-" + 27 + "-fixed"]:
        selectedDataRecord && selectedDataRecord.address[0].id
          ? selectedDataRecord.address[0].id
          : undefined,
      ["isPrimary-" + 28 + "-fixed"]: true,
      ["appAddressTypeId-" + 29 + "-fixed"]: 1,
      ["initial-" + 5]: values["initial-" + 5] ? values["initial-" + 5] : '',
      ["phone1-" + 16]: values["phone1-" + 16] ? values["phone1-" + 16] : '',
      ["firstLineOfRecipientName-" + 2]: values["firstLineOfRecipientName-" + 2] ? values["firstLineOfRecipientName-" + 2] : '',
      ["secondLineOfRecipientName-" + 3]: values["secondLineOfRecipientName-" + 3] ? values["secondLineOfRecipientName-" + 3] : '',
    };
    let t5RecipientFlexFieldsWithTrustAcc: any = {
      ...values,
      ["postalCode-" + 12 + "-fixed"]:
        values["postalCode-" + 12 + "-fixed"] &&
        values["postalCode-" + 12 + "-fixed"].replace(
          /[a-z]/g,
          (match: string) => match.toUpperCase()
        ),
      ["name1-" + 3 + "-fixed"]:
        values["name1-" + 3 + "-fixed"] !== ""
          ? values["name1-" + 3 + "-fixed"]
          : undefined,
      ["email-" + 15 + "-fixed"]:
        values["email-" + 15 + "-fixed"] !== ""
          ? values["email-" + 15 + "-fixed"]
          : undefined,
      ["uniqueIdentifier-" + 2 + "-fixed"]:
        (values["uniqueIdentifier-" + 2 + "-fixed"] &&
          values["uniqueIdentifier-" + 2 + "-fixed"] !== "") ||
          null
          ? values["uniqueIdentifier-" + 2 + "-fixed"].replace(/-/g, "")
          : undefined,
      // addressId:
      ["id-" + 27 + "-fixed"]:
        selectedDataRecord && selectedDataRecord.address[0].id
          ? selectedDataRecord.address[0].id
          : undefined,
      ["isPrimary-" + 28 + "-fixed"]: true,
      ["appAddressTypeId-" + 29 + "-fixed"]: 1,
      ["initial-" + 5]: values["initial-" + 5] ? values["initial-" + 5] : '',
      ["phone1-" + 16]: values["phone1-" + 16] ? values["phone1-" + 16] : '',
    };


    //add category fields in meta fields
    // const categoryFields = () => {
    //   if (
    //     selectedCategoriesData &&
    //     selectedCategoriesData.length > 0 &&
    //     resourceCategoryList &&
    //     resourceCategoryList.items.length > 0
    //   ) {
    //     const makeSelectedCategoryAsMetaField = selectedCategoriesData.map(
    //       (item: any) => ({
    //         fieldId: item.categoryFieldId,
    //         name: "categoryField",
    //         value: item.categoryFieldValue,
    //       })
    //     );

    //     return makeSelectedCategoryAsMetaField;
    //   } else {
    //     return [];
    //   }
    // };

    // const categoryFieldsAsMetaFields = categoryFields();

    let payload = FlexFieldsUtils.formatFixedAndMetaFieldsWithAddressArray(
      resourceName === "Vendor"
        ? vendorFlexFields
        : resourceName === "Employee"
          ? employeeFlexFields
          : values['recipientType-' + 1] === "40" ? t5RecipientFlexFieldsWithTrustAcc : t5RecipientFlexFields,
      metaFieldIds
    );
    payload.id = id;
    payload.clientId = clientId;
    payload.taxYear = taxYear;
    payload.dataRoleName = resourceName;
    // payload.metaFields = payload.metaFields
    //   .filter((field: any) => field.name !== `load_${resourceName}`)
    //   .concat(
    //     categoryFieldsAsMetaFields && categoryFieldsAsMetaFields.length > 0
    //       ? categoryFieldsAsMetaFields
    //       : []
    //   );


    submitFormFields(payload);
  };

  // useEffect(() => {
  //   if (id && selectedDataRecord) {
  //     //category fields update default values
  //     let metaFields = selectedDataRecord.metaFields;
  //     let categoryField = metaFields.filter(
  //       (element: any) => element.name === "categoryField"
  //     );

  //     if (
  //       categoryField &&
  //       categoryField.length > 0
  //       //  && resourceCategoryList &&
  //       // resourceCategoryList.items.length > 0
  //     ) {
  //       const selectedCategoriesFieldsData = categoryField.map((item: any) => ({
  //         screenId: screenId,
  //         categoryFieldId: parseInt(item.fieldId),
  //         categoryFieldValue: item.value,
  //       }));
  //       setSelectedCategoriesData((prevData: any) => [
  //         ...prevData,
  //         ...selectedCategoriesFieldsData,
  //       ]);

  //       //get all category data from category list
  //       let selectedCategoriesDataIds =
  //         categoryField &&
  //         categoryField.map((item: any) => parseInt(item.fieldId));

  //       const addDefaultValueInCategoryFields = resourceCategoryList.items
  //         .filter((listItem: any) =>
  //           categoryField.find(
  //             (item: any) => parseInt(item.fieldId) === listItem.id
  //           )
  //         )
  //         .map((listItem: any) => {
  //           const matchingCategory: any = categoryField.find(
  //             (item: any) => parseInt(item.fieldId) === listItem.id
  //           );
  //           return {
  //             ...listItem,
  //             defaultValue: matchingCategory.value,
  //           };
  //         });


  //       const finalCategoriesListWithDefaultValue =
  //         resourceCategoryList.items.map((metaCategory: any) => {
  //           const matchingItem = addDefaultValueInCategoryFields.find(
  //             (categoryListItem: any) => categoryListItem.id === metaCategory.id
  //           );
  //           return matchingItem ? matchingItem : metaCategory;
  //         });
  //       setResourceTotalCategories({
  //         items: finalCategoriesListWithDefaultValue,
  //       });

  //     }
  //   }
  // }, [id, selectedDataRecord, resourceCategoryList]);

  useEffect(() => {
    // TODO: Navigate to Unauthorized page or permissions denied page
    if (!clientId) {
      navigate(homePathRoute);
    }
  }, [clientId, navigate]);

  const onResourceSelectionChangeHandler = async (
    selectedItem: any,
    index?: any
  ): Promise<void> => {

    dispatch(clearSelectedResourceApiMessageActions());

    //this is for card selection
    setSelectedCard(index);

    if (!index) {
      //this is for card selection
      setSelectedCard(selectedItem.value);
    }

    // alert(selectedItem.value)
    if (selectedItem.value === "create-new") {
      // setSnackbarData({
      //   open: true,
      //   message: "Please load an employee",
      //   severity: "error",
      // });
      let path = `/resources/${resourceName}/setup`;
      navigate(path);

      let totalPanels: any = [];
      if (resourceName === "Employee") {
        // totalPanels.unshift(selectedResourceList && selectedResourceList);
        employeeScreenFields &&
          employeeScreenFields.map((item: any) => {

            totalPanels.push(item);
            if (
              // selectedResourceList &&
              totalPanels &&
              totalPanels.length !== 0
            ) {
              setResourceTotalPanels(totalPanels);
            }
          });
      } else if (resourceName === "Vendor") {
        // totalPanels.unshift(selectedResourceList && selectedResourceList);
        vendorScreenFields &&
          vendorScreenFields.map((item: any) => {
            totalPanels.push(item);
            if (
              // selectedResourceList &&
              totalPanels &&
              totalPanels.length !== 0
            ) {
              setResourceTotalPanels(totalPanels);
            }
          });
      } else if (resourceName === "T5_Recipient") {
        // totalPanels.unshift(selectedResourceList && selectedResourceList);
        t5RecipientScreenFields &&
          t5RecipientScreenFields.map((item: any) => {
            totalPanels.push(item);
            if (
              // selectedResourceList &&
              totalPanels &&
              totalPanels.length !== 0
            ) {
              setResourceTotalPanels(totalPanels);
            }
          });
      } else if (resourceName === "T3_Beneficiary") {
        // totalPanels.unshift(selectedResourceList && selectedResourceList);
        t3BeneficiaryScreenFields &&
          t3BeneficiaryScreenFields.map((item: any) => {
            totalPanels.push(item);
            if (
              // selectedResourceList &&
              totalPanels &&
              totalPanels.length !== 0
            ) {
              setResourceTotalPanels(totalPanels);
            }
          });
      }
      // Show form in add mode
      // setRenderForm(true);
      // //null all defualt values
      // screenFields && screenFields?.panels.forEach((screenPanel: IPanel) => {
      //   screenPanel?.fields?.forEach((field: IField) => {
      //   field.defaultValue =
      //     field.fieldId === "statusId" ? field.defaultValue :
      //     field.fieldId === "countryId" ? field.defaultValue :
      //     resourceName === "Employee" && field.fieldId === "employee_type" ? field.defaultValue :
      //     resourceName === "Employee" && field.fieldId === "pay_period" ? field.defaultValue :
      //     resourceName === "Employee" && field.fieldId === "reduced_ei" ? field.defaultValue :
      //     resourceName === "Vendor" && field.fieldId === "payeeType" ? field.defaultValue : null
      //   })
      // })
      // setIsLoadingData(true);
      // setTimeout(() => {
      //   setIsLoadingData(false);
      // }, 1000);
      window.location.reload();
      setSelectedCard(null);
    } else {
      // try {
      // setIsLoadingData(true);
      // const responseGetResourceActualId = await T4SlipService.getResourceActualId(
      //   selectedItem.value
      //   );
      let path = `/resources/${resourceName}/setup/${selectedItem.value}`;
      navigate(path);
      // setEditRecordId(responseGetResourceActualId && responseGetResourceActualId.resourceId)
      // setEditRecordId(undefined)

      // refetchResourceDataById()
      window.location.reload();


      // setSelectedResource(String(response.resourceId));
      // setSelectedResourceId(String(response.resourceId));
      // if (response.resourceId !== "create new"){
      //   setEditedResourceId(String(response.resourceId));
      // }
      // window.location.reload()
      //null all defualt values
      // (async () => {
      //   try {
      //     setIsLoadingData(true)
      //     let resourceDataById = await ResourceService.getById(responseGetResourceActualId.resourceId, String(resourceName), clientId);
      //  
      //     if(resourceDataById){
      //         screenFields && screenFields?.panels.forEach((screenPanel: IPanel) => {
      //           screenPanel?.fields?.forEach((field: IField) => {
      //             field.defaultValue =
      //             field.fieldId === "statusId" ? field.defaultValue :
      //             field.fieldId === "countryId" ? field.defaultValue :
      //             resourceName === "Employee" && field.fieldId === "employee_type" ? field.defaultValue :
      //             resourceName === "Employee" && field.fieldId === "pay_period" ? field.defaultValue :
      //             resourceName === "Employee" && field.fieldId === "reduced_ei" ? field.defaultValue :
      //             resourceName === "Vendor" && field.fieldId === "payeeType" ? field.defaultValue : null
      //           })
      //         })
      //         if(resourceName === "Employee"){
      //           (async () => {
      //             try {
      //               const responseAssociationId = await T4SlipService.getRoleAssociationId(
      //                 responseGetResourceActualId.resourceId
      //               );
      //               loadResourcePanel && loadResourcePanel?.fields?.forEach((field: any) => field.defaultValue = responseAssociationId.associationId)
      //             } catch(err){
      //               alert(err)
      //             }
      //           })();
      //         }

      //         if (
      //           screenFields &&
      //           // Array.isArray(screenFields) &&
      //           resourceDataById &&
      //           instanceOfIResource(resourceDataById)
      //         ) {
      //           
      //           let metaFieldIdsObject: { [key: string]: string } = {};
      //           // screenFields.forEach((screenTab: ITabLayout, index: number) => {
      //             screenFields.panels.forEach((screenPanel: IPanel, index: number) => {
      //               screenPanel.fields.forEach((field: IField) => {
      //                 let isAddressField = AddressFields.find(
      //                   (element) => element === field.fieldId
      //                 );
      //                

      //                 if (
      //                   field.isFixed &&
      //                   resourceDataById.hasOwnProperty(field.fieldId) &&
      //                   !isAddressField
      //                 ) {
      //                   type objectKey = keyof typeof resourceDataById;
      //                   let fieldValue = field.fieldId as objectKey;
      //                   field.defaultValue = resourceDataById[fieldValue] !== null ? String(resourceDataById[fieldValue]) : "";
      //                   if(field.fieldId === 'uniqueIdentifier'){
      //                     field.defaultValue = resourceDataById[fieldValue] !== null ? String(resourceDataById[fieldValue]).replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3") : "";
      //                   }
      //                   if(field.fieldId === 'email'){
      //                     const maskedStatus:any = sessionStorage.getItem("maskEnabled")
      //                     field.defaultValue = resourceDataById[fieldValue] !== null ? String(resourceDataById[fieldValue]) : resourceDataById[fieldValue] === null && maskedStatus === "true" ? "ze*****3@gmail.com" : resourceDataById[fieldValue];
      //                   }
      //               
      //                 } else if (field.isFixed && isAddressField) {
      //                   let addressObject = resourceDataById.address[0];
      //                   type addressObjectKey = keyof typeof addressObject;
      //                   let addressFieldKey = field.fieldId as addressObjectKey;
      //                   field.defaultValue = addressObject[addressFieldKey];

      //                   if (
      //                     String(addressFieldKey) === "country" ||
      //                     String(addressFieldKey) === "countryId"
      //                   ) {
      //                 
      //                     field.defaultValue = String(addressObject.country.id);
      //                   } else if (
      //                     String(addressFieldKey) === "province" ||
      //                     String(addressFieldKey) === "provinceId"
      //                   ) {
      //                  
      //                     field.defaultValue = String(addressObject.province.id);
      //                   }
      //                 } else if (!field.isFixed) {
      //               
      //                   let metaFields = resourceDataById.metaFields;
      //                   let metaField:any = metaFields.find(
      //                     (element:any) => element.name === field.fieldId
      //                   );
      //                   if (metaField) {
      //                     metaFieldIdsObject[field.fieldId] = metaField.id;
      //                     field.defaultValue = metaField.value;
      //                     if(metaField.name === "reduced_ei"){
      //                       if(metaField.value === true){
      //                         field.defaultValue = "True"
      //                       } else {
      //                         field.defaultValue = "False"
      //                       }
      //                     }
      //                     if(metaField.name === "payeeType"){
      //                       setPayeeType(metaField.value)
      //                     }
      //                     if(metaField.name === "date_of_birth"){
      //                       const maskedStatus:any = sessionStorage.getItem("maskEnabled")
      //                  
      //                       if(maskedStatus === "true"){
      //                         field.defaultValue = metaField.value !== "" ? metaField.value : "1****";
      //                         field.dataType = DataType.String;
      //                       } else {
      //                         field.defaultValue = metaField.value;
      //                       }
      //                     }
      //                   }
      //                 } else {
      //             
      //                 }
      //               });
      //               // Show form in edit mode when all data is loaded
      //               if (index === screenFields.panels.length - 1) {
      //                 setRenderForm(true);
      //               }
      //             });
      //           setMetaFieldIds(metaFieldIdsObject);
      //     
      //         }
      //   
      //     }
      //   } catch (error) {
      //     setIsLoadingData(false)
      //     console.error("Error fetching data:", error);
      //   } finally {
      //     setIsLoadingData(false)
      //     let path = `/resources/${resourceName}/setup/${responseGetResourceActualId.resourceId}`;
      //     navigate(path);
      //     setEditRecordId(responseGetResourceActualId && responseGetResourceActualId.resourceId)
      //   }
      // })();
      // } catch (err) {
      //   // setIsLoadingData(false)
      //   

      //   // alert(err);
      // }
      // finally{
      //   // setIsLoadingData(false)
      // }
    }
  };

  //remove load Employee panel bcz of cards selection
  // let loadResourcePanel = [
  //   {
  //     name: `Load ${resourceName}`,
  //     description: `Load ${resourceName}`,
  //     sequence: 1,
  //     categoryFields: [],
  //     panels: [
  //       {
  //         label: `Load ${
  //           resourceName === "T5_Recipient" ? "T5 Recipient" : resourceName
  //         }`,
  //         categoryFieldId: "",
  //         categoryFieldValue: "",
  //         sequence: 1,
  //         gridColumns: 12 as GridSize,
  //         fields: [
  //           {
  //             id: 1,
  //             fieldLabel: `Load ${
  //               resourceName === "T5_Recipient" ? "T5 Recipient" : resourceName
  //             }`,
  //             fieldId: `load_${resourceName}`,
  //             fieldType: FieldType.DropDownList,
  //             placeholder: "",
  //             fieldValue: "Create New",
  //             fieldInternalValue: "create-new",
  //             onChange: onResourceSelectionChangeHandler,
  //             dataType: DataType.Object,
  //             fieldFormat: "",
  //             defaultValue: "create-new",
  //             labelPosition: "left",
  //             labelColumn: 4 as GridSize,
  //             fieldColumn: 8 as GridSize,
  //             fullFieldColumns: 12,
  //             notes: "",
  //             minValue: "",
  //             maxValue: "",
  //             parent: null,
  //             parentValue: "",
  //             parentRelation: null,
  //             isFixed: false,
  //             isRequired: false,
  //             isCategory: false,
  //             isHide: false,
  //             readOnly: false,
  //             displayMasked: false,
  //             uppercase: false,

  //             fieldClass: "",
  //             validationFormula: "",
  //             comparison: [],
  //             employeeAccess: 0,
  //             variableValue: null,
  //             systemField: false,
  //             apiPath: null,
  //             sequence: 7,
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // ] as ITabLayout[];

  useEffect(() => {

    if (id) {
      //cards
      setSelectedCard(String(id));
      //null all defualt values
      resourceTotalPanels &&
        resourceTotalPanels.forEach((item: any) => {
          item?.panels.forEach((screenPanel: IPanel) => {
            screenPanel?.fields?.forEach((field: IField) => {
              field.defaultValue =
                // field.fieldId === "statusId"
                //   ? field.defaultValue
                //   : field.fieldId === "statusId"
                //   ? field.defaultValue :
                field.fieldId === "countryId"
                  ? field.defaultValue
                  : field.fieldId === `load_${resourceName}`
                    ? field.defaultValue
                    : resourceName === "Employee" &&
                      field.fieldId === "employee_type"
                      ? field.defaultValue
                      : resourceName === "Employee" &&
                        field.fieldId === "pay_period"
                        ? field.defaultValue
                        : resourceName === "Employee" &&
                          field.fieldId === "reduced_ei"
                          ? field.defaultValue
                          : resourceName === "T5_Recipient" &&
                            field.fieldId === "recipientType"
                            ? field.defaultValue
                            : resourceName === "T3_Beneficiary" &&
                              field.fieldId === "recipientType"
                              ? field.defaultValue
                              : resourceName === "Vendor" && field.fieldId === "payeeType"
                                ? field.defaultValue
                                : null;
            });
          });
        });
      if (resourceTotalPanels) {
        // (async () => {
        //   try {
        //     const responseAssociationId = await T4SlipService.getRoleAssociationId(
        //       id
        //     );
        //   
        // loadResourcePanel && loadResourcePanel?.fields?.forEach((field: any) => field.defaultValue = responseAssociationId.associationId)
        // resourceTotalPanels[0].panels[0].fields[0].defaultValue = id;

        // loadResourcePanel && loadResourcePanel.forEach((item:any) => {
        //   item?.panels.forEach((screenPanel: IPanel) => {
        //   screenPanel?.fields?.forEach((field: any) => field.defaultValue = responseAssociationId.associationId)
        //   })
        //   })
        //   } catch(err){
        //     alert(err)
        //   }
        // })();
      }

      if (resourceName === "T5_Recipient" && selectedDataRecord && selectedDataRecord.metaFields) {
        let metaFields = selectedDataRecord.metaFields;
        let metaField: any = metaFields.find(
          (element: any) => element.name === 'recipientType'
        );
        if (metaField.name === "recipientType") {
          if (recipientTypeChangeOnEditMode === true) {
            setRecipientType(parseInt(metaField.value));
          }
        }
      } else if (resourceName === "T3_Beneficiary" && selectedDataRecord && selectedDataRecord.metaFields) {
        let metaFields = selectedDataRecord.metaFields;
        let metaField: any = metaFields.find(
          (element: any) => element.name === 'recipientType'
        );
        if (metaField.name === "recipientType") {
          if (recipientTypeChangeOnEditMode === true) {
            setRecipientType(parseInt(metaField.value));
          }
        }
      }

      if (
        resourceTotalPanels &&
        // Array.isArray(screenFields) &&
        selectedDataRecord &&
        instanceOfIResource(selectedDataRecord)
      ) {

        let metaFieldIdsObject: { [key: string]: string } = {};
        // screenFields.forEach((screenTab: ITabLayout, index: number) => {
        resourceTotalPanels &&
          resourceTotalPanels.forEach((item: any) => {
            item.panels.forEach((screenPanel: IPanel, index: number) => {
              screenPanel.fields.forEach((field: IField) => {
                let isAddressField = AddressFields.find(
                  (element) => element === field.fieldId
                );


                if (field.isFixed &&
                  field.fieldId === "statusId") {
                  type objectKey = keyof typeof selectedDataRecord;
                  let fieldValue = 'status' as objectKey;
                  field.defaultValue =
                    selectedDataRecord[fieldValue] === "Active" ? 13 :
                      selectedDataRecord[fieldValue] === "In-Active" ? 14
                        : "Active";

                } else

                  if (
                    field.isFixed &&
                    selectedDataRecord.hasOwnProperty(field.fieldId) &&
                    !isAddressField
                  ) {
                    type objectKey = keyof typeof selectedDataRecord;
                    let fieldValue = field.fieldId as objectKey;
                    field.defaultValue =
                      selectedDataRecord[fieldValue] !== null
                        ? String(selectedDataRecord[fieldValue])
                        : "";
                    if (field.fieldId === "uniqueIdentifier") {
                      field.defaultValue =
                        selectedDataRecord[fieldValue] !== null
                          ? String(selectedDataRecord[fieldValue]).replace(
                            /(\d{3})(\d{3})(\d{3})/,
                            "$1-$2-$3"
                          )
                          : "";
                    }
                    if (field.fieldId === "email") {
                      // const maskedStatus: any =
                      //   sessionStorage.getItem("maskEnabled");
                      field.defaultValue =
                        selectedDataRecord[fieldValue] !== null
                          ? String(selectedDataRecord[fieldValue])
                          : selectedDataRecord[fieldValue] === null &&
                            dashboardApiData.masked_status === true
                            ? "ze*****3@gmail.com"
                            : selectedDataRecord[fieldValue];
                    }

                  } else if (field.isFixed && isAddressField) {
                    let addressObject = selectedDataRecord.address[0];
                    type addressObjectKey = keyof typeof addressObject;
                    let addressFieldKey = field.fieldId as addressObjectKey;
                    field.defaultValue = addressObject[addressFieldKey];

                    if (
                      String(addressFieldKey) === "country" ||
                      String(addressFieldKey) === "countryId"
                    ) {

                      field.defaultValue = String(addressObject.country.id);
                    } else if (
                      String(addressFieldKey) === "province" ||
                      String(addressFieldKey) === "provinceId"
                    ) {

                      field.defaultValue = String(addressObject.province.id);
                    }
                  } else if (!field.isFixed) {

                    let metaFields = selectedDataRecord.metaFields;
                    let metaField: any = metaFields.find(
                      (element: any) => element.name === field.fieldId
                    );
                    if (metaField) {
                      metaFieldIdsObject[field.fieldId] = metaField.id;
                      if (field.fieldId !== `load_${resourceName}`) {
                        field.defaultValue = metaField.value;
                      }
                      if (metaField.name === "reduced_ei") {
                        if (metaField.value === true) {
                          field.defaultValue = "True";
                        } else {
                          field.defaultValue = "False";
                        }
                      }
                      if (metaField.name === "payeeType" && field.fieldId === "payeeType") {
                        if (metaField.value === true) {
                          setPayeeType('true');
                          field.defaultValue = 'true';
                        } else if (metaField.value === false) {
                          setPayeeType('false');
                          field.defaultValue = 'false';
                        } else {
                          setPayeeType(metaField.value);
                          field.defaultValue = metaField.value;
                        }
                      }
                      if (metaField.name === "recipientType") {
                        field.defaultValue = parseInt(metaField.value);
                        // if(recipientTypeChangeOnEditMode === true){
                        //   setRecipientType(parseInt(metaField.value));
                        // }
                      }
                      if (metaField.name === "date_of_birth") {
                        // const maskedStatus: any =
                        //   sessionStorage.getItem("maskEnabled");

                        // console.log("maskedStatus::",maskedStatus)
                        if (dashboardApiData.masked_status) {
                          field.defaultValue =
                            metaField.value !== "" ? metaField.value : "1****";
                          field.dataType = DataType.String;
                        } else {
                          // field.defaultValue = metaField.value !== "" ? metaField.value : "1****";
                          field.defaultValue = metaField.value !== "" ? dayjs(metaField.value) : null;
                        }
                      }
                    }
                  } else {

                  }
              });
              // Show form in edit mode when all data is loaded
              screenFields &&
                screenFields.forEach((item: any) => {
                  if (index === item.panels.length - 1) {
                    setRenderForm(true);
                  }
                });
            });
          });

        setMetaFieldIds(metaFieldIdsObject);

      }
    } else {
      // Show form in add mode
      setRenderForm(true);
      //null all defualt values
      screenFields &&
        screenFields.forEach((item: any) => {
          item?.panels.forEach((screenPanel: IPanel) => {
            screenPanel?.fields.forEach((field: IField) => {
              field.defaultValue =
                field.fieldId === "statusId"
                  ? field.defaultValue
                  : field.fieldId === "countryId"
                    ? field.defaultValue
                    : field.fieldId === `load_${resourceName}`
                      ? field.defaultValue
                      : resourceName === "Employee" &&
                        field.fieldId === "employee_type"
                        ? field.defaultValue
                        : resourceName === "Employee" &&
                          field.fieldId === "pay_period"
                          ? field.defaultValue
                          : resourceName === "Employee" &&
                            field.fieldId === "reduced_ei"
                            ? field.defaultValue
                            : resourceName === "T5_Recipient" &&
                              field.fieldId === "recipientType"
                              ? field.defaultValue
                              : resourceName === "T3_Beneficiary" &&
                                field.fieldId === "recipientType"
                                ? field.defaultValue
                                : resourceName === "Vendor" && field.fieldId === "payeeType"
                                  ? field.defaultValue
                                  : null;
            });
          });
        });
    }

    if (!id && !selectedDataRecord && resourceName === "Employee") {

      defaultSettingsCalls()
    }
  }, [
    id,
    screenFields,
    selectedDataRecord,
    // resourceCategoryList,
    resourceTotalPanels,
    resourceName
  ]);

  // useEffect(()=>{
  //   if(id){
  //     loadResourcePanel && loadResourcePanel.forEach((item:any) => {
  //       item?.panels.forEach((screenPanel: IPanel) => {
  //       screenPanel?.fields?.forEach((field: any) => field.defaultValue = "4b965748-39e5-43b5-8dae-a194b13d43d3")
  //       })
  //     })

  //   }
  // },[id,loadResourcePanel])
  // if (id && loadResourcePanel) {
  //   loadResourcePanel.forEach(item => {
  //     item.panels.forEach(screenPanel => {
  //       screenPanel.fields.forEach(field => {
  //         if (field.fieldId === `load_${resourceName}`) {
  //           field.defaultValue = "4b965748-39e5-43b5-8dae-a194b13d43d3";
  //         }
  //       });
  //     });
  //   });
  // }

  const onSnackbarClosed = (
    _event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarData(INITIAL_SNACKBAR_DATA);
  };

  const onSubmitAllTabs = (formData: any) => {

  };
  const initialValues = {
    name: "",
    age: "",
    Address: "",
  };

  // useEffect(() => {
  //   if (
  //     resourceCategoryList &&
  //     resourceCategoryList.items &&
  //     resourceCategoryList.items.length === 1 &&
  //     resourceCategoryList.items[0].defualtCategory === true
  //   ) {

  //   } else if (resourceCategoryList && resourceCategoryList.items) {

  //     const categoryWithOnChange = resourceCategoryList.items.map(
  //       (item: any) => {
  //         let updatedCategories: any = [];
  //         // let selectedCategory: any = [];

  //         // for (let i = 0; i < resourceCategoryList.items.length; i++) {
  //         if (item.fieldType === "DropDownList") {
  //           if (item.defualtCategory === true) {
  //             let fieldData = {
  //               screenId: screenId,
  //               categoryFieldId: item.id,
  //               categoryFieldValue: item.fieldInternalValue,
  //             };
  //             setSelectedCategoriesData((prevData: any) => [
  //               ...prevData,
  //               fieldData,
  //             ]);
  //             updatedCategories.push(item);
  //             item.isHide = true;
  //             item.readOnly = true;
  //             item.isRequired = false;
  //             // item.fieldLabel=''
  //           } else {
  //             const onDropDownChanged = (value: any) => {

  //               let fieldData = {
  //                 screenId: screenId,
  //                 categoryFieldId: item.id,
  //                 categoryFieldValue: value.value,
  //               };
  //               // setSelectedCategoriesData((prevData: any) => [...prevData, fieldData]);
  //               setSelectedCategoriesData((prevData: any[]) => {
  //                 // Check if an object with the same categoryFieldId exists
  //                 const existingIndex = prevData.findIndex(
  //                   (data) => data.categoryFieldId === fieldData.categoryFieldId
  //                 );

  //                 if (existingIndex !== -1) {
  //                   // If exists, remove it
  //                   const newData = prevData.filter(
  //                     (data, index) => index !== existingIndex
  //                   );
  //                   // Add the new object
  //                   return [...newData, fieldData];
  //                 } else {
  //                   // If not exists, just add the new object
  //                   return [...prevData, fieldData];
  //                 }
  //               });
  //             };
  //             item.onChange = onDropDownChanged;
  //             updatedCategories.push(item);

  //           }
  //         } else if (item.fieldType === "NormalSwitch") {
  //           if (item.defualtCategory === true) {
  //             let fieldData = {
  //               screenId: screenId,
  //               categoryFieldId: item.id,
  //               categoryFieldValue: item.fieldInternalValue,
  //             };
  //             setSelectedCategoriesData((prevData: any) => [
  //               ...prevData,
  //               fieldData,
  //             ]);
  //             updatedCategories.push(item);
  //             item.isHide = true;
  //             item.readOnly = true;
  //             item.isRequired = false;
  //             // item.fieldLabel=''
  //           } else {
  //             const onSwitchChanged = (value: any) => {
  //               let fieldData = {
  //                 screenId: screenId,
  //                 categoryFieldId: item.id,
  //                 categoryFieldValue: value,
  //               };
  //               // setSelectedCategoriesData((prevData: any) => [...prevData, fieldData]);
  //               setSelectedCategoriesData((prevData: any[]) => {
  //                 // Check if an object with the same categoryFieldId exists
  //                 const existingIndex = prevData.findIndex(
  //                   (data) => data.categoryFieldId === fieldData.categoryFieldId
  //                 );

  //                 if (existingIndex !== -1) {
  //                   // If exists, remove it
  //                   const newData = prevData.filter(
  //                     (data, index) => index !== existingIndex
  //                   );
  //                   // Add the new object
  //                   return [...newData, fieldData];
  //                 } else {
  //                   // If not exists, just add the new object
  //                   return [...prevData, fieldData];
  //                 }
  //               });
  //             };
  //             item.onChange = onSwitchChanged;
  //             updatedCategories.push(item);
  //           }
  //         } else if (item.fieldType === "MultiSelectionDropDownList") {
  //           if (item.defualtCategory === true) {
  //             let fieldData = {
  //               screenId: screenId,
  //               categoryFieldId: item.id,
  //               categoryFieldValue: item.fieldInternalValue,
  //             };
  //             setSelectedCategoriesData((prevData: any) => [
  //               ...prevData,
  //               fieldData,
  //             ]);
  //             updatedCategories.push(item);
  //             item.isHide = true;
  //             item.readOnly = true;
  //             item.isRequired = false;
  //             // item.fieldLabel=''
  //           } else {
  //             const onMultiSelectionDropDownValueChanged = (value: any) => {
  //               let selectedItems: any = [];
  //               value.map((item: any) => {
  //                 selectedItems.push(item.value);
  //               });
  //               let fieldData = {
  //                 screenId: screenId,
  //                 categoryFieldId: item.id,
  //                 categoryFieldValue: selectedItems,
  //               };
  //               // setSelectedCategoriesData((prevData: any) => [...prevData, fieldData]);
  //               setSelectedCategoriesData((prevData: any[]) => {
  //                 // Check if an object with the same categoryFieldId exists
  //                 const existingIndex = prevData.findIndex(
  //                   (data) => data.categoryFieldId === fieldData.categoryFieldId
  //                 );

  //                 if (existingIndex !== -1) {
  //                   // If exists, remove it
  //                   const newData = prevData.filter(
  //                     (data, index) => index !== existingIndex
  //                   );
  //                   // Add the new object
  //                   return [...newData, fieldData];
  //                 } else {
  //                   // If not exists, just add the new object
  //                   return [...prevData, fieldData];
  //                 }
  //               });
  //             };
  //             item.onChange = onMultiSelectionDropDownValueChanged;
  //             updatedCategories.push(item);
  //           }
  //         } else if (item.fieldType === "Checkbox") {
  //           if (item.defualtCategory === true) {
  //             let fieldData = {
  //               screenId: screenId,
  //               categoryFieldId: item.id,
  //               categoryFieldValue: item.fieldInternalValue,
  //             };
  //             setSelectedCategoriesData((prevData: any) => [
  //               ...prevData,
  //               fieldData,
  //             ]);
  //             updatedCategories.push(item);
  //             item.isHide = true;
  //             item.readOnly = true;
  //             item.isRequired = false;
  //             // item.fieldLabel=''
  //           } else {
  //             const onCheckBoxValueChanged = (value: any) => {
  //               let fieldData = {
  //                 screenId: screenId,
  //                 categoryFieldId: item.id,
  //                 categoryFieldValue: value,
  //               };
  //               // setSelectedCategoriesData((prevData: any) => [...prevData, fieldData]);
  //               setSelectedCategoriesData((prevData: any[]) => {
  //                 // Check if an object with the same categoryFieldId exists
  //                 const existingIndex = prevData.findIndex(
  //                   (data) => data.categoryFieldId === fieldData.categoryFieldId
  //                 );

  //                 if (existingIndex !== -1) {
  //                   // If exists, remove it
  //                   const newData = prevData.filter(
  //                     (data, index) => index !== existingIndex
  //                   );
  //                   // Add the new object
  //                   return [...newData, fieldData];
  //                 } else {
  //                   // If not exists, just add the new object
  //                   return [...prevData, fieldData];
  //                 }
  //               });
  //             };
  //             item.onChange = onCheckBoxValueChanged;
  //             updatedCategories.push(item);
  //           }
  //         } else if (item.fieldType === "RadioGroup") {
  //           if (item.defualtCategory === true) {
  //             let fieldData = {
  //               screenId: screenId,
  //               categoryFieldId: item.id,
  //               categoryFieldValue: item.fieldInternalValue,
  //             };
  //             setSelectedCategoriesData((prevData: any) => [
  //               ...prevData,
  //               fieldData,
  //             ]);
  //             updatedCategories.push(item);
  //             item.isHide = true;
  //             item.readOnly = true;
  //             item.isRequired = false;
  //             // item.fieldLabel=''
  //           } else {
  //             const onRadioButtonValueChanged = (e: any) => {
  //               let fieldData = {
  //                 screenId: screenId,
  //                 categoryFieldId: item.id,
  //                 categoryFieldValue: e.target.value,
  //               };
  //               // setSelectedCategoriesData((prevData: any) => [...prevData, fieldData]);
  //               setSelectedCategoriesData((prevData: any[]) => {
  //                 // Check if an object with the same categoryFieldId exists
  //                 const existingIndex = prevData.findIndex(
  //                   (data) => data.categoryFieldId === fieldData.categoryFieldId
  //                 );

  //                 if (existingIndex !== -1) {
  //                   // If exists, remove it
  //                   const newData = prevData.filter(
  //                     (data, index) => index !== existingIndex
  //                   );
  //                   // Add the new object
  //                   return [...newData, fieldData];
  //                 } else {
  //                   // If not exists, just add the new object
  //                   return [...prevData, fieldData];
  //                 }
  //               });
  //             };
  //             item.onChange = onRadioButtonValueChanged;
  //             updatedCategories.push(item);
  //           }
  //         } else {
  //           if (item.defualtCategory === true) {
  //             let fieldData = {
  //               screenId: screenId,
  //               categoryFieldId: item.id,
  //               categoryFieldValue: item.fieldInternalValue,
  //             };
  //             setSelectedCategoriesData((prevData: any) => [
  //               ...prevData,
  //               fieldData,
  //             ]);
  //             updatedCategories.push(item);
  //             item.isHide = true;
  //             item.readOnly = true;
  //             item.isRequired = false;
  //             // item.fieldLabel=''
  //           } else {
  //             let fieldData = {
  //               screenId: screenId,
  //               categoryFieldId: item.id,
  //               categoryFieldValue: item.fieldInternalValue,
  //             };
  //             // setSelectedCategoriesData((prevData: any) => [...prevData, fieldData]);
  //             setSelectedCategoriesData((prevData: any[]) => {
  //               // Check if an object with the same categoryFieldId exists
  //               const existingIndex = prevData.findIndex(
  //                 (data) => data.categoryFieldId === fieldData.categoryFieldId
  //               );

  //               if (existingIndex !== -1) {
  //                 // If exists, remove it
  //                 const newData = prevData.filter(
  //                   (data, index) => index !== existingIndex
  //                 );
  //                 // Add the new object
  //                 return [...newData, fieldData];
  //               } else {
  //                 // If not exists, just add the new object
  //                 return [...prevData, fieldData];
  //               }
  //             });
  //             updatedCategories.push(item);
  //           }
  //         }

  //         return item;
  //         // }
  //       }
  //     );

  //     setCategoryFieldsWithOnChangeMethod(categoryWithOnChange);
  //   }
  // }, [resourceCategoryList]);

  const { isPending: isDeleting, mutate: deleteResourceById } = useMutation({
    mutationFn: ResourceService.delResource,

    onSuccess: (res: string | IServerError | IResponse | any) => {
      if (res === "Resource has been deleted successfully") {
        // remove the cache of the Year fields since we just added a new field.
        setSnackbarData({
          open: true,
          message: "Record has been deleted successfully.",
          severity: "success",
        });
        let path = `/resources/${resourceName}/list`;
        navigate(path);
      } else {
        setSnackbarData({
          open: true,
          message: res && res.message ? res.message : "Something went wrong!",
          severity: res && res.status === false ? "error" : "success",
        });
      }
    },
    onError: (err) => {
      // TODO: customize the toast message based on the response
      setSnackbarData({
        open: true,
        message: "Something went wrong, try again later!",
        severity: "error",
      });
    },
  }
  );

  const deleteResourceField = (e: string) => {
    if (singleDelete) {
      setSingleDelete(false);
      let payload = {
        resourceId: resourceId,
        roleName: resourceName,
        clientId: clientId,
        taxYear: taxYear,
        option: e,
      };
      deleteResourceById(payload);
      setDialogOpen(false);
    }
  };

  const onDeleteClicked = () => {
    setDialogOpen(true);
    setSingleDelete(true);
    if (selectedDataRecord) {
      setResourceId(selectedDataRecord.id);
    }
  };

  const onCloseHandler = () => {
    setDialogOpen(false);
  };

  const onResetClicked = () => {
    setSnackbarData({
      open: true,
      message: "Form was reset successfully",
      severity: "success",
    });
    // formMethods.reset();
    // let path = `/accountants/setup`;
    // navigate(path);
  };

  // useEffect(()=>{
  //   if(!resourceCategoryAssingedPanels && resourceName === "Employee"){
  //     (async () => {
  //       try {
  //         setIsLoadingData(true)
  //         const response: any = await T4SlipService.getEmployeeDDL(clientId, EMPLOYEE_RESOURCE_LITERAL);
  //        

  //         // Extract labels and values from data
  //         let labels = response && response.map((item:any) => item.label);
  //         let values = response && response.map((item:any) => item.value);

  //         // Join labels and values into a single string
  //         // Join labels and values into a single string
  //         let fieldValue = response && response.length > 0 ? `Create New,${labels.join(',')}` : "Create New";
  //         let fieldInternalValue = response && response.length > 0 ? `create-new,${values.join(',')}` : "create-new";

  //        

  //         const finalLoadResourcePanel = {
  //           ...loadResourcePanel,
  //           fields: loadResourcePanel.fields.map((field:any) => ({
  //             ...field,
  //             fieldValue: fieldValue,
  //             fieldInternalValue: fieldInternalValue,
  //           })),
  //         };


  //           setSelectedResourceList(finalLoadResourcePanel);
  //       } catch (error) {
  //         setIsLoadingData(false)
  //         console.error("Error fetching data:", error);
  //       } finally {
  //         setIsLoadingData(false)
  //       }
  //     })();
  //   }
  // },[])
  // useEffect(() => {
  //   // if(!resourceCategoryAssingedPanels && resourceName === "Vendor"){
  //   // if(!resourceCategoryAssingedPanels){
  //   if (id) {
  //     // (async () => {
  //     //   try {
  //     //     const responseAssociationId = await T4SlipService.getRoleAssociationId(
  //     //       id
  //     //     );
  //     (async () => {
  //       try {
  //         setIsLoadingData(true);
  //         const response: any = await T4SlipService.getEmployeeDDL(
  //           clientId,
  //           resourceName === "Employee"
  //             ? EMPLOYEE_RESOURCE_LITERAL
  //             : resourceName === "Vendor"
  //               ? VENDOR_RESOURCE_LITERAL
  //               : resourceName === "T5_Recipient" ? T5_RECIPIENT_RESOURCE_LITERAL
  //                 : 'T3_Beneficiary',
  //           taxYear
  //         );


  //         // let labels = response && response.map((item: any) => item.label);
  //         // let values = response && response.map((item: any) => item.value);

  //         // let fieldValue =
  //         //   response && response.length > 0
  //         //     ? `Create New,${labels.join(",")}`
  //         //     : "Create New";
  //         // let fieldInternalValue =
  //         //   response && response.length > 0
  //         //     ? `create-new,${values.join(",")}`
  //         //     : "create-new";



  //         // let defaultValue = id;
  //         // const finalLoadResourcePanel = loadResourcePanel.map((panel) => ({
  //         //   ...panel,
  //         //   panels: panel.panels.map((panel) => ({
  //         //     ...panel,
  //         //     fields: panel.fields.map((field) => ({
  //         //       ...field,
  //         //       defaultValue: defaultValue, // Update defaultValue
  //         //       fieldValue: fieldValue, // Update fieldValue
  //         //       fieldInternalValue: fieldInternalValue, // Update fieldInternalValue
  //         //     })),
  //         //   })),
  //         // }));


  //         // setSelectedResourceList(finalLoadResourcePanel[0]);
  //         setResourceListWithoutCreateNew(response);
  //       } catch (error) {
  //         setIsLoadingData(false);
  //         console.error("Error fetching data:", error);
  //       } finally {
  //         setIsLoadingData(false);
  //       }
  //     })();
  //     //   } catch(err){
  //     //     alert(err)
  //     //   }
  //     // })();
  //   } else {
  //     (async () => {
  //       try {
  //         setIsLoadingData(true);
  //         const response: any = await T4SlipService.getEmployeeDDL(
  //           clientId,
  //           resourceName === "Employee"
  //             ? EMPLOYEE_RESOURCE_LITERAL
  //             : resourceName === "Vendor"
  //               ? VENDOR_RESOURCE_LITERAL
  //               : resourceName === "T5_Recipient" ? T5_RECIPIENT_RESOURCE_LITERAL
  //                 : 'T3_Beneficiary',
  //           taxYear
  //         );


  //         // let labels = response && response.map((item: any) => item.label);
  //         // let values = response && response.map((item: any) => item.value);

  //         // let fieldValue =
  //         //   response && response.length > 0
  //         //     ? `Create New,${labels.join(",")}`
  //         //     : "Create New";
  //         // let fieldInternalValue =
  //         //   response && response.length > 0
  //         //     ? `create-new,${values.join(",")}`
  //         //     : "create-new";


  //         // const finalLoadResourcePanel = loadResourcePanel.map((panel) => ({
  //         //   ...panel,
  //         //   panels: panel.panels.map((panel) => ({
  //         //     ...panel,
  //         //     fields: panel.fields.map((field) => ({
  //         //       ...field,
  //         //       fieldValue: fieldValue, // Update fieldValue
  //         //       fieldInternalValue: fieldInternalValue, // Update fieldInternalValue
  //         //     })),
  //         //   })),
  //         // }));


  //         // setSelectedResourceList(finalLoadResourcePanel[0]);
  //         setResourceListWithoutCreateNew(response);
  //       } catch (error) {
  //         setIsLoadingData(false);
  //         console.error("Error fetching data:", error);
  //       } finally {
  //         setIsLoadingData(false);
  //       }
  //     })();
  //   }
  //   // }
  // }, [id]);

  useEffect(() => {
    let totalPanels: any = [];
    // if (
    //   resourceCategoryAssingedPanels &&
    //   resourceCategoryAssingedPanels.length > 0
    // ) {
    //   if (resourceName === "Employee") {
    //     // employeeScreenFields?.panels.map((item: any) => {
    //     //   totalPanels.push(item);
    //     // });
    //     employeeScreenFields &&
    //       employeeScreenFields.map((item: any) => {
    //         // totalPanels.unshift(selectedResourceList && selectedResourceList);
    //         totalPanels.push(item);
    //       });
    //   } else if (resourceName === "Vendor") {
    //     vendorScreenFields &&
    //       vendorScreenFields.map((item: any) => {
    //         // totalPanels.unshift(selectedResourceList && selectedResourceList);
    //         totalPanels.push(item);
    //       });
    //   } else if (resourceName === "T5_Recipient") {
    //     t5RecipientScreenFields &&
    //       t5RecipientScreenFields.map((item: any) => {
    //         // totalPanels.unshift(selectedResourceList && selectedResourceList);
    //         totalPanels.push(item);
    //       });
    //   } else if (resourceName === "T3_Beneficiary") {
    //     t3BeneficiaryScreenFields &&
    //       t3BeneficiaryScreenFields.map((item: any) => {
    //         // totalPanels.unshift(selectedResourceList && selectedResourceList);
    //         totalPanels.push(item);
    //       });
    //   }
    //   // resourceCategoryAssingedPanels?.panels.map((item: any) => {
    //   //   totalPanels.push(item);
    //   // });
    //   const makeAllFieldsToMetaFields =
    //     resourceCategoryAssingedPanels &&
    //     resourceCategoryAssingedPanels.map((item: any) => {
    //       return {
    //         ...item,
    //         panels: item.panels.map((panel: any) => {
    //           return {
    //             ...panel,
    //             fields: panel.fields.map((field: any) => ({
    //               ...field,
    //               fieldId: field.appFieldLabel,
    //               isFixed: false, //now all fields is meta field
    //             })),
    //           };
    //         }),
    //       };
    //     });
    //   //make all field to isFixed false to make it meta field
    //   makeAllFieldsToMetaFields.map((item: any) => {
    //     totalPanels.push(item);
    //   });
    //   // totalPanels.push(resourceCategoryAssingedPanels.panels)
    //   if (totalPanels && totalPanels.length !== 0) {
    //     // let resourceTolalPanel = {
    //     //   panels: totalPanels,
    //     // };
    //     setResourceTotalPanels(totalPanels);
    //   }
    // } else {
    if (resourceName === "Employee") {
      // totalPanels.unshift(selectedResourceList && selectedResourceList);

      // employeeScreenFields?.panels.map((item: any) => {

      //   totalPanels.push(item);
      //   if (selectedResourceList && totalPanels && totalPanels.length !== 0) {
      //     let resourceTolalPanel = {
      //       panels: totalPanels,
      //     };
      //     setResourceTotalPanels(resourceTolalPanel);
      //   }
      // });
      employeeScreenFields &&
        employeeScreenFields.map((item: any) => {

          totalPanels.push(item);
          if (
            // selectedResourceList &&
            totalPanels &&
            totalPanels.length !== 0
          ) {
            // let resourceTolalPanel = {
            //   panels: totalPanels,
            // };
            setResourceTotalPanels(totalPanels);
          }
        });
    } else if (resourceName === "Vendor") {
      // totalPanels.unshift(selectedResourceList && selectedResourceList);
      vendorScreenFields &&
        vendorScreenFields.map((item: any) => {
          totalPanels.push(item);
          if (
            // selectedResourceList &&
            totalPanels &&
            totalPanels.length !== 0
          ) {
            // let resourceTolalPanel = {
            //   panels: totalPanels,
            // };
            setResourceTotalPanels(totalPanels);
          }
        });
    } else if (resourceName === "T5_Recipient") {
      // totalPanels.unshift(selectedResourceList && selectedResourceList);
      t5RecipientScreenFields &&
        t5RecipientScreenFields.map((item: any) => {
          totalPanels.push(item);
          if (
            // selectedResourceList &&
            totalPanels &&
            totalPanels.length !== 0
          ) {
            // let resourceTolalPanel = {
            //   panels: totalPanels,
            // };
            setResourceTotalPanels(totalPanels);
          }
        });
    } else if (resourceName === "T3_Beneficiary") {
      // totalPanels.unshift(selectedResourceList && selectedResourceList);
      t3BeneficiaryScreenFields &&
        t3BeneficiaryScreenFields.map((item: any) => {
          totalPanels.push(item);
          if (
            // selectedResourceList &&
            totalPanels &&
            totalPanels.length !== 0
          ) {
            // let resourceTolalPanel = {
            //   panels: totalPanels,
            // };
            setResourceTotalPanels(totalPanels);
          }
        });
    }
    // totalPanels.push(screenFields?.panels);

    // };
  }, [
    vendorScreenFields,
    employeeScreenFields,
    t5RecipientScreenFields,
    screenFields,
    // resourceCategoryAssingedPanels,
    // selectedResourceList,
  ]);


  // useEffect(() => {
  //   if (
  //     resourceCategoryList &&
  //     resourceCategoryList.items &&
  //     resourceCategoryList.items.length === 1 &&
  //     resourceCategoryList.items[0].defualtCategory === true
  //   ) {
  //     const fieldData = {
  //       screenId: screenId,
  //       categoryFieldId: resourceCategoryList.items[0].id,
  //       categoryFieldValue: resourceCategoryList.items[0].fieldInternalValue,
  //     };


  //     setSelectedCategoriesData((prevData: any) => [...prevData, fieldData]);
  //   }
  // }, [resourceCategoryList]);

  useEffect(() => {
    if (screenFields) {
      if (resourceName === "Vendor") {

        screenFields &&
          screenFields[0]?.panels[0]?.fields?.map((item: any) => {
            if (item.fieldId === "payeeType") {
              const onPayeeTypeChanged = (value: any) => {
                setPayeeType(value.value);

                if (value.value === payeeType) {

                } else {
                  setScreenFields(undefined);
                  setResourceTotalPanels(undefined);

                }
              };
              item.onChange = onPayeeTypeChanged;
            }

          });

      } else if (resourceName === "T5_Recipient") {
        screenFields &&
          screenFields[0]?.panels[0]?.fields?.map((item: any) => {
            if (item.fieldId === "recipientType") {
              const onRecipientTypeChanged = (value: any) => {
                setRecipientTypeChangeOnEditMode(false)
                setRecipientType(value.value);

                if (value.value === recipientType) {

                } else {
                  setScreenFields(undefined);
                  setResourceTotalPanels(undefined);

                }
              };
              item.onChange = onRecipientTypeChanged;
            }

          });
      } else if (resourceName === "T3_Beneficiary") {
        screenFields &&
          screenFields[0]?.panels[0]?.fields?.map((item: any) => {
            if (item.fieldId === "recipientType") {
              const onRecipientTypeChanged = (value: any) => {
                setRecipientTypeChangeOnEditMode(false)
                setRecipientType(value.value);

                if (value.value === recipientType) {

                } else {
                  setScreenFields(undefined);
                  setResourceTotalPanels(undefined);

                }
              };
              item.onChange = onRecipientTypeChanged;
            }

          });
      }
    }
  }, [screenFields]);

  useEffect(() => {
    dispatch(
      setSelectedActivityLogActions({
        entityId1: id ? id : "",
        entityId2: "",
        entityId3: "",
        screenName:
          resourceName === "Employee"
            ? EMPLOYEE_SETUP_SCREEN_SLUG
            : resourceName === "Vendor"
              ? VENDOR_SETUP_SCREEN_SLUG
              : resourceName === "T5_Recipient"
                ? T5_RECIPIENT_SETUP_SCREEN_SLUG
                : resourceName === "T3_Beneficiary"
                  ? T3_BENEFICIARY_SETUP_SCREEN_SLUG
                  : 0,
        companyName: clientName,
        activityType: "activity_type=create&activity_type=updated&activity_type=delete",
        activityLogVisibility: true,
      })
    );
    dispatch(setSelectedStickyNavBar({ isSticky: true }));
  }, [resourceName]);

  const defaultValuesOfResourceForm = useCallback(() => {
    const fieldsDefaultValues: any = {};
    resourceTotalPanels &&
      resourceTotalPanels.forEach((tabLayout: any) => {
        tabLayout?.panels.forEach((panel: any) => {
          panel?.fields.forEach((panelField: any) => {
            const FieldComponent: any =
              FIELD_TYPE_COMPONENT[panelField.fieldType];
            if (FieldComponent) {
              const { fieldId, id, isFixed, defaultValue, fieldType } =
                panelField;
              const fieldName = getFieldName(fieldId, id, isFixed);
              let fieldDefaultValue = panelField.defaultValue;

              if (fieldType === FieldType.MultiSelectionDropDownList) {
                if (defaultValue) {
                  fieldDefaultValue = getMultiSelectionDDLDefaultValue(
                    defaultValue as string
                  );
                }
              }
              // if the field has a default value
              if (fieldDefaultValue) {
                fieldsDefaultValues[fieldName] = fieldDefaultValue;
              }
              // else if (fieldDefaultValue === null) {
              //   fieldsDefaultValues[fieldName] = fieldDefaultValue;
              // }
            }
          });
        });
      });
    return fieldsDefaultValues;
  }, [resourceTotalPanels, getFieldName]);

  const defaultValuesOfResourceCategpryForm = useCallback(() => {
    const fieldsDefaultValues: any = {};
    resourceTotalCategories &&
      resourceTotalCategories?.items.forEach((panelField: any) => {
        const FieldComponent: any = FIELD_TYPE_COMPONENT[panelField.fieldType];
        if (FieldComponent) {
          const { fieldId, id, isFixed, defaultValue, fieldType } = panelField;
          const fieldName = getFieldName(fieldId, id, isFixed);
          let fieldDefaultValue = defaultValue;

          if (fieldType === FieldType.MultiSelectionDropDownList) {
            if (defaultValue) {
              fieldDefaultValue = getMultiSelectionDDLDefaultValue(
                defaultValue as string
              );
            }
          }
          // if the field has a default value
          if (fieldDefaultValue) {
            fieldsDefaultValues[fieldName] = fieldDefaultValue;
          }
        }
      });
    return fieldsDefaultValues;
  }, [resourceTotalCategories, getFieldName]);

  //after creating resource this message would be shown
  useEffect(() => {
    if (
      showCreatedResourceMessage === true &&
      resourceApiMessage &&
      resourceApiMessage.open === true
    ) {
      setSnackbarData({
        open: resourceApiMessage.open,
        message: resourceApiMessage.message,
        severity: resourceApiMessage.severity,
      });
    }
  }, [resourceApiMessage]);

  //cards
  const getCardStyles = (index: any) => {

    return {
      borderLeft:
        selectedCard === index ? "6px solid #0057db" : "2px solid transparent",
      cursor: "pointer",
    };
  };
  // const getSelectedResourceSlipInCard = (index: any) => {
  //   let selectedItem =
  //     selectedCard === index ? selectedResourceSlip : "create-new";
  //   return selectedItem;
  // };
  // const getSelectedResourceSlipsListInCard = (index: any) => {
  //   let selectedList =
  //     selectedCard === index
  //       ? selectedResourceSlipList
  //       : [{ label: "Create New", value: "create-new" }];
  //   return selectedList;
  // };

  const filteredResourceList =
    employeeDDLItems &&
    sortDDLByLabel(employeeDDLItems).filter((item: any) =>
      item.label.toLowerCase().includes(itemSearch.toLowerCase())
    );

  const onCreateNewButtonClicked = () => {
    dispatch(clearSelectedResourceApiMessageActions());
    let path = `/resources/${resourceName}/setup`;
    navigate(path);
    window.location.reload();
    setSelectedCard(null);
  };
  const onDividerButtonClickHandler = () => {
    setSidePanelsVisibility((prevButtonState: any) => !prevButtonState);
  };
  // useEffect(() => {
  //   if (flexFieldPanelHeightRef.current) {
  //     const heightInPx = flexFieldPanelHeightRef.current.getBoundingClientRect().height;

  //     const baseFontSizeInPx = 16; // Default base font size

  //     const heightInRem = `${heightInPx / baseFontSizeInPx}rem`;

  //     let height = parseInt(heightInRem) - 5

  //     setFlexFieldPanelHeight(`${height}rem`)
  //   }
  // }, [flexFieldPanelHeightRef])

  return (
    <Grid
      container
      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
      sx={{
        // pb: "5rem",
        "& .MuiAppBar-root": { zIndex: 2, top: "65px" },
        paddingTop: "2rem",
      }}>
      <BackdropCircularProgress
        open={
          // isSubmitting ||
          isLoadingById ||
          isDeleting ||
          isLoadingData ||
          // isLoadingResourceCategories ||
          // isLoadingResourceCategoriesPanels ||
          isLoadingVendorScreenLayout ||
          isLoadingEmployeeScreenLayout ||
          isLoadingT5RecipientScreenLayout ||
          isLoadingT3BeneficiaryScreenLayout ||
          // isLoadingClientProfileDataById ||
          isLoadingActivityLogData
          // ||isLoadingDefaultSettingsData
          || isPendingEmployeeDDLItems
        }
        testId="accountant Setup"
      />
      {/* <DeleteConfirmationDialog
        open={openDialog}
        deleteActionHandler={deleteResourceField}
        cancelActionHandler={onCloseHandler}
        testId="accountant-confirmation-dialog"
      /> */}
      {/* <Grid
        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{
          paddingBottom: "2rem",
        }}>
        {resourceTotalCategories &&
          resourceTotalCategories?.items &&
          resourceTotalCategories.items.length === 1 &&
          resourceTotalCategories.items[0].defualtCategory === true ? (
          <></>
        ) : resourceTotalCategories &&
          resourceTotalCategories.items &&
          resourceTotalCategories.items.length > 0 ? (
          <CategoryFieldsPanelLayout
            categoryFields={
              resourceTotalCategories?.items &&
                categoryFieldsWithOnChangeMethod !== undefined
                ? categoryFieldsWithOnChangeMethod
                : []
            }
            panelLabel={`${resourceName} Categories`}
            formDefaultValues={defaultValuesOfResourceCategpryForm()}
            testId={"categoryFields-panel"}
          />
        ) : (
          <></>
        )}</Grid> */}
      {sidePanelsVisibility && (
        <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
          <Box sx={{ margin: "0" }}>
            <InputText
              value={itemSearch}
              onChange={(e) => setItemSearch(e.target.value)}
              placeholder={"Search by name..."}
              className="w-full search-field"
            />
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              <Button
                variant="contained"
                sx={{ right: 0, margin: "10px 0px", fontSize: "12px" }}
                onClick={onCreateNewButtonClicked}
              >
                + Create New
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              // display: "flex",
              height: `${
                // resourceCategoryAssingedPanels && flexFieldPanelHeight ? flexFieldPanelHeight :
                resourceName === 'Employee' ? '59.2rem' :
                  resourceName === 'Vendor' ? '37rem' :
                    resourceName === 'T5_Recipient' ? '37rem' :
                      resourceName === 'T3_Beneficiary' ? '37rem' :
                        'auto'}`,
              overflow: "auto",
              "&::-webkit-scrollbar": {
                width: "0.4em",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#ccc",
                borderRadius: "3px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#aaa",
              },
            }}
          >
            {employeeDDLItems &&
              filteredResourceList.map((item: any, index: any) => {
                return (
                  <Card
                    sx={{
                      padding: 0,
                      borderRadius: "8px",
                      marginBottom: "1rem",
                    }}
                    key={index}
                    onClick={() =>
                      onResourceSelectionChangeHandler(item, item.value)
                    }
                    style={getCardStyles(item.value)}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "0.8rem",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: "bold", fontSize: ".875rem" }}
                      >
                        {item.label}
                      </Typography>
                      <Avatar
                        shape="circle"
                        style={{
                          background: "#0057db",
                          color: "#fff",
                          borderRadius: "50%",
                          fontWeight: "bold",
                          fontSize: ".775rem",
                          padding: "2px",
                        }}
                      >
                        {item.label
                          .replace(/\s+/g, " ")
                          .split(" ")
                          .filter((word: string) => word.trim() !== "")
                          .map((word: string) => word[0].toUpperCase())
                          .slice(0, 2)
                          .join("")}
                      </Avatar>
                    </Box>
                  </Card>
                );
              })}
          </Box>
        </Grid>
      )}
      <Divider
        layout="vertical"
        align="center"
        className="verticle-divider"
        style={{ zIndex: 0 }}
      >
        <Button
          variant="outlined"
          sx={{
            minWidth: "fit-content",
            padding: "20px 0",
            borderRadius: "7px",
          }}
          onClick={onDividerButtonClickHandler}
        >
          {sidePanelsVisibility ? (
            <i
              className="pi pi-angle-double-left"
              style={{ color: "#0057db" }}
            ></i>
          ) : (
            <i
              className="pi pi-angle-double-right"
              style={{ color: "#0057db" }}
            ></i>
          )}
        </Button>
      </Divider>
      <Grid
        size={{
          xs: sidePanelsVisibility ? 8 : 10,
          sm: sidePanelsVisibility ? 8 : 10.8,
          md: sidePanelsVisibility ? 9.4 : 11.2,
          lg: sidePanelsVisibility ? 9.5 : 11.6,
          xl: sidePanelsVisibility ? 9.7 : 11.7
        }}
        sx={{ "& .MuiGrid-container": { marginTop: 0 }, "& .MuiGrid-root": { paddingTop: 0 } }}
        ref={flexFieldPanelHeightRef}
      >
        <SetupFormLayout
          isLoadingData={
            isLoadingEmployeeScreenLayout ||
            isLoadingVendorScreenLayout ||
            isLoadingById
          }
          renderForm={renderForm}
          isSubmittingForm={false}
          forMultipleColumn={true}
        >
          {/* <Card
              >
        <ReourceSetupToolbar
            onResetClicked={onResetClicked}
            onDeleteClicked={onDeleteClicked}
            isSubmitting={isSubmitting}
            resourceDataById={selectedDataRecord}
          /></Card> */}
          <FlexFieldsFormPanelLayout
            toolbar={
              <ReourceSetupToolbar
                onResetClicked={onResetClicked}
                onDeleteClicked={onDeleteClicked}
                isSubmitting={isSubmitting}
                resourceDataById={selectedDataRecord}
              />
            }
            onSubmit={onSubmit}
            formLayout={
              screenFields && resourceTotalPanels && resourceTotalPanels
            }
            formDefaultValues={defaultValuesOfResourceForm()}
            testId={"clientCategoryAssingedPanels"}
            validationSchema={resourceJSONdataValidation}
          />
          {/* Single Delete Options to delte by year or permanenet */}
          <EnhancedDialog
            dialogTitle="Please Confirm"
            key="dialog-box"
            testId="dialog"
            onCloseHandler={onCloseHandler}
            open={openDialog}
            dialogContent={
              <Typography>Are you sure, you want to delete?</Typography>
            }
            dialogAction={
              <Grid>
                <Button
                  autoFocus
                  variant="contained"
                  onClick={onCloseHandler}
                  sx={{
                    background: "#fff",
                    color: "#000",
                    marginLeft: "16px",
                    "&.MuiButton-root:hover": { background: "#fff" },
                    fontSize: "small",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  autoFocus
                  variant="contained"
                  startIcon={<DeleteIcon />}
                  onClick={() => deleteResourceField("Delete By Year")}
                  color="error"
                  sx={{ marginLeft: "16px", fontSize: "small" }}
                >
                  Delete By Year
                </Button>
                <Button
                  autoFocus
                  variant="contained"
                  startIcon={<DeleteIcon />}
                  onClick={() => deleteResourceField("Permanent Delete")}
                  color="error"
                  sx={{ marginLeft: "16px", fontSize: "small" }}
                >
                  Permanenet Delete
                </Button>
              </Grid>
            }
          />
          <EnhancedSnackbar
            message={snackbarData.message}
            onCloseHandler={onSnackbarClosed}
            severity={snackbarData.severity}
            testId={"accountant-snackbar"}
            open={snackbarData.open}
          />
        </SetupFormLayout>
      </Grid>
    </Grid>

    //old form method using rhook form
    // <SetupFormLayout
    //   isLoadingData={isLoading || isLoadingById}
    //   renderForm={renderForm}
    //   isSubmittingForm={isSubmitting}
    // >
    //   {screenFields && Array.isArray(screenFields) && (
    //     <RHookFormGenerator
    //       formLayout={screenFields}
    //       onSubmit={onSubmit}
    //       testId="resource-setup-form"
    //     />
    //   )}
    //   <EnhancedSnackbar
    //     message={snackbarData.message}
    //     onCloseHandler={onSnackbarClosed}
    //     severity={snackbarData.severity}
    //     testId={"resource-snackbar"}
    //     open={snackbarData.open}
    //   />
    // </SetupFormLayout>

    //stepper from to set validation for every step
    // <StepperForm onSubmit={onSubmitAllTabs} initialValues={initialValues}/>
  );
};
